<template>
	<div class="wrap">
		<div class="spinner-border--wrap" v-if="isLoading">
			<div class="spinner-border" role="status">
				<span class="visually-hidden">Loading...</span>
			</div>
		</div>
		<div class="content" v-if="item">
			<div class="detail-page">
				<div class="detail-page--top">
					<div class="left">
						<div
							class="state"
							v-bind:class="{
								'bg-grey': item.sell_status == 'hold',
								'bg-lgrey': item.sell_status == 'ready',
								'bg-red': item.sell_status == 'sell',
							}"
						>
							<span class="date">{{ $dateFormat(item.reg_date) }}</span>
							<span class="date">
								<template v-if="item.sell_status == 'done'">
									{{ $dateFormat(item.done_date_time) }}
								</template>
								<template v-else>&nbsp;</template>
							</span>
							<p
								class="name"
								v-bind:class="{
									'text-secondary': item.sell_status == 'ready',
									'text-dark': item.sell_status == 'hold',
									'text-danger': item.sell_status == 'sell',
								}"
							>
								{{ $ITEM_STATE2[item.sell_status] }}
							</p>
						</div>
					</div>
					<div class="info">
						<div class="top">
							<b-icon-journal-text /> 물건번호 : {{ item.building_uid }}
							<button
								type="button"
								class="btn btn-sm"
								v-bind:class="{ 'btn-primary': item.chk_status == 'A', 'btn-secondary': item.chk_status != 'A' }"
							>
								A
							</button>
							<button
								type="button"
								class="btn btn-sm"
								v-bind:class="{ 'btn-primary': item.chk_status == 'B', 'btn-secondary': item.chk_status != 'B' }"
							>
								B
							</button>
							<button
								type="button"
								class="btn btn-sm"
								v-bind:class="{ 'btn-primary': item.chk_status == 'C', 'btn-secondary': item.chk_status != 'C' }"
							>
								C
							</button>
						</div>
						<div class="bottom">
							{{ item.building_name }}
						</div>
					</div>
					<div class="count">
						<div class="box">
							조회
							<span class="num"
								><span class="txt-c--blue">{{ viewObj.today_view_cnt }}</span> / {{ viewObj.max_view_cnt }}</span
							>
						</div>
						<div class="box">
							출력
							<span class="num"
								><span class="txt-c--blue">{{ viewObj.today_print_cnt }}</span> / {{ viewObj.max_print_cnt }}</span
							>
						</div>
					</div>
					<div class="input-box">
						<!-- G-2: 담당자 좌측 (기존 종류 자리) — 좌우 반전 per spec -->
						<label class="label">담당자</label>
						<select class="form-control select" v-model="item.building_mem_uid">
							<option value="">담당자 선택</option>
							<option v-for="m in memList" :key="m.mem_uid" :value="m.mem_uid">
								{{ m.mem_name }} {{ m.mem_rank_name }}
							</option>
						</select>

						<!-- G-2: 작업하기 UI 우측 — sell_status='done'(매물)/'sell'(매각) 일 때 완전히 숨김 -->
						<template v-if="!hideWorkUi">
							<span v-if="isWorkingActive" class="tag-shape tag-shape--working">
								작업기한 : {{ $dateFormat(item.working_edate) }}
							</span>
							<template v-else>
								<span class="tag-shape tag-shape--available">작업가능</span>
								<button type="button" class="btn btn-sm btn-primary" @click="btnStartWork">작업하기</button>
							</template>
						</template>
					</div>
					<div class="right">
						<div class="top">
							<button type="button" class="btn btn-sm btn-outline-secondary" @click="isPopupShow2 = true">
								<b-icon-file-earmark />&nbsp;첨부파일
							</button>
							<button type="button" class="btn btn-sm btn-outline-secondary" @click="btnOnPrint">
								<b-icon-printer />&nbsp;출력
							</button>
						</div>
						<div class="bottom">
							<button
								v-if="$store.getters.getUserInfo.mem_type == 'master'"
								type="button"
								class="btn btn-sm btn-danger"
								@click="delItem()"
							>
								<b-icon-trash-fill />
							</button>
							<button type="button" class="btn btn-sm btn-secondary" @click="backMenu()">View Mode</button>
							<button type="button" class="btn btn-sm btn-primary" @click="btnSaveItem()">저장</button>
						</div>
					</div>
				</div>
				<div class="detail-page--con">
					<div class="left">
						<div class="con">
							<div class="tit">
								물건정보
								<button type="button" class="btn btn-xxsm btn-secondary" @click="isPopupShow1 = true">연결물건</button>
								<button type="button" class="btn btn-xxsm btn-secondary" @click="isPopupShow5 = true">
									<b-icon-filter-square-fill />
								</button>
							</div>
							<table class="table type-input">
								<colgroup>
									<col width="20%" />
									<col width="30%" />
									<col width="20%" />
									<col width="30%" />
								</colgroup>
								<tr>
									<th>물건명</th>
									<td colspan="3">
										<input type="text" class="form-control" v-model="item.building_name" ref="building_name" />
									</td>
								</tr>
								<tr>
									<th>표출용주소</th>
									<td colspan="3"><input type="text" class="form-control" v-model="item.show_addr" /></td>
								</tr>
								<tr>
									<th>지번주소</th>
									<td colspan="3">{{ item.jibun_addr }}</td>
								</tr>
								<tr>
									<th>도로명주소</th>
									<td colspan="3">
										{{ item.road_addr }}
										<button type="button" class="btn map1" @click.stop="$openNaverMap(item.jibun_addr)"></button>
										<button type="button" class="btn map2" @click.stop="$openDaumMap(item.jibun_addr)"></button>
									</td>
								</tr>
								<tr>
									<th>연결주소</th>
									<td colspan="3">
										<input type="text" class="form-control" readonly v-model="linkAddr" />
										<button type="button" class="btn btn-xxsm btn-secondary" @click="btnOnCreateMap()">추가</button>
									</td>
								</tr>
								<tr>
									<th>주변역</th>
									<td>
										<input type="text" class="form-control" v-model="item.substation" ref="substation" />
									</td>
									<th>거리(M)</th>
									<td>
										<input
											type="number"
											class="form-control"
											v-model="item.substation_distance"
											ref="substation_distance"
										/>
									</td>
								</tr>
								<tr>
									<th>진행상태</th>
									<td>
										<label class="input-checkbox">
											<input type="radio" name="state" value="ready" @change="chgSellStatus()" v-model="sell_status" :disabled="chgSellStatusPending" />
											<span class="checkbox radio"></span>
											<span class="text">준비</span>
										</label>
										<label class="input-checkbox">
											<input type="radio" name="state" value="done" @change="chgSellStatus()" v-model="sell_status" :disabled="chgSellStatusPending" />
											<span class="checkbox radio"></span>
											<span class="text">매물</span>
										</label>
										<label class="input-checkbox">
											<input type="radio" name="state" value="hold" @change="chgSellStatus()" v-model="sell_status" :disabled="chgSellStatusPending" />
											<span class="checkbox radio"></span>
											<span class="text">보류</span>
										</label>
										<label class="input-checkbox">
											<input type="radio" name="state" value="sell" @change="chgSellStatus()" v-model="sell_status" :disabled="chgSellStatusPending" />
											<span class="checkbox radio"></span>
											<span class="text">임대완료</span>
										</label>
									</td>
									<th>상태</th>
									<td>
										<select class="form-control select" v-model="item.chk_status">
											<option value="">선택</option>
											<option value="A">A</option>
											<option value="B">B</option>
											<option value="C">C</option>
										</select>
									</td>
								</tr>
								<tr>
									<th>물건사진</th>
									<td colspan="3">
										<button type="button" class="btn btn-xxsm btn-secondary" @click="isPopupShow7 = true">추가</button>
									</td>
								</tr>
							</table>
						</div>
						<div class="con">
							<div class="tit">
								토지대장
								<button type="button" class="btn icon" @click="btnReload"><b-icon-arrow-repeat /></button>
								<button type="button" class="btn btn-xxsm btn-secondary" @click="goKras">조회</button>
							</div>
							<table class="table type-input">
								<tr>
									<th>지번</th>
									<th>지목</th>
									<th>면적(㎡)</th>
									<th>용도지역</th>
									<th>제한사항</th>
									<th>공시지가(원/㎡)</th>
								</tr>
								<tr :key="'land_' + land.id" v-for="land in landList">
									<td>{{ land.jibun }}</td>
									<td>{{ land.gmok_name }}</td>
									<td>{{ $formatArea(land.size_m2) }}</td>
									<td>{{ land.use_area_name }}</td>
									<td>{{ land.district_code_name }}</td>
									<td>
										{{ $formatMoney(land.public_land_price_m2, $MONEY_FORMAT_TYPE.LOAN) }}

										<template v-if="land.public_land_price_year">
											<br />
											({{ land.public_land_price_year }}년 기준)
										</template>
									</td>
								</tr>
							</table>
						</div>
						<div class="con">
							<div class="tit">토지정보</div>
							<table class="table type-input">
								<colgroup>
									<col width="20%" />
									<col width="30%" />
									<col width="20%" />
									<col width="30%" />
								</colgroup>
								<tr>
									<th>대지면적</th>
									<td colspan="3">
										<input
											type="text"
											class="form-control xsm"
											ref="land_size_p"
											v-model="item.land_size_p"
											@change="item.land_size_m2 = $py_m2_ex(item.land_size_p)"
										/>
										&nbsp;평&nbsp;
										<input
											type="text"
											class="form-control xsm"
											v-model="item.land_size_m2"
											@change="item.land_size_p = $m2_py_ex(item.land_size_m2)"
										/>
										&nbsp;㎡
									</td>
								</tr>
								<tr>
									<th>지목</th>
									<td>
										<select v-model="item.gmok" class="form-control select" ref="gmok">
											<option value="">선택</option>
											<option v-for="c in typeList.gmok" :key="'gmok' + c.ind_cfg_uid" :value="c.ind_cfg_uid">
												{{ c.cfg_val1 }}
											</option>
										</select>
									</td>
									<th>건폐율</th>
									<td>
										<input type="text" class="form-control xsm" v-model="item.bl_ratio" /><span class="text">%</span>
									</td>
								</tr>
								<tr>
									<th>용도지역</th>
									<td colspan="3">
										<select v-model="item.use_area_uid" class="form-control select" ref="use_area_uid">
											<option value="" selected>선택</option>
											<option v-for="c in typeList.use_area" :key="'use_area' + c.ind_cfg_uid" :value="c.ind_cfg_uid">
												{{ c.cfg_val1 }}
											</option>
										</select>
									</td>
								</tr>
								<tr>
									<th>
										공시지가
										<button type="button" class="btn p-0" @click="btnReload"><b-icon-arrow-repeat /></button>
									</th>
									<td>
										<money3 class="form-control sm" v-model="item.public_land_price" v-bind="$MONEY1"></money3>
										<span class="text">만</span>
									</td>
									<th>평단가</th>
									<td>
										<money3 class="form-control sm" v-model="item.public_land_price_py_price" v-bind="$MONEY1"></money3>
										<span class="text">만</span>
									</td>
								</tr>
								<tr>
									<th>도로사항</th>
									<td colspan="3">
										<label class="input-checkbox">
											<input type="checkbox" v-model="item.chk_road_coner" true-value="Y" false-value="N" />
											<span class="checkbox"></span>
											<span class="text">코너</span>
										</label>
										<label class="input-checkbox">
											<input type="checkbox" v-model="item.chk_road_dual" true-value="Y" false-value="N" />
											<span class="checkbox"></span>
											<span class="text">양면</span>
										</label>
										<br />
										<input
											type="text"
											class="form-control sm"
											placeholder="도로명"
											v-model="item.road_name"
											ref="road_name"
										/>
										<br />
										<input
											type="number"
											class="form-control sm"
											placeholder="m"
											v-model="item.roadwide_1"
											ref="roadwide_1"
										/>
										<input
											type="number"
											class="form-control sm"
											placeholder="m"
											v-model="item.roadwide_2"
											ref="roadwide_2"
										/>
										<input
											type="number"
											class="form-control sm"
											placeholder="m"
											v-model="item.roadwide_3"
											ref="roadwide_3"
										/>
										<input
											type="number"
											class="form-control sm"
											placeholder="m"
											v-model="item.roadwide_4"
											ref="roadwide_4"
										/>
									</td>
								</tr>
							</table>
						</div>
						<div class="con">
							<div class="tit">건축물정보</div>
							<table class="table type-input">
								<colgroup>
									<col width="20%" />
									<col width="30%" />
									<col width="20%" />
									<col width="30%" />
								</colgroup>
								<tr>
									<th>연면적</th>
									<td colspan="3">
										<input
											type="text"
											class="form-control xsm"
											v-model="item.total_size_p"
											@change="item.total_size_m2 = $py_m2_ex(item.total_size_p)"
										/>
										&nbsp;평&nbsp;
										<input
											type="text"
											class="form-control xsm"
											v-model="item.total_size_m2"
											@change="item.total_size_p = $m2_py_ex(item.total_size_m2)"
										/>
										&nbsp;㎡
									</td>
								</tr>
								<tr>
									<th>건축면적</th>
									<td colspan="3">
										<input
											type="text"
											class="form-control xsm"
											v-model="item.build_size_p"
											@change="item.build_size_m2 = $py_m2_ex(item.build_size_p)"
										/>
										&nbsp;평&nbsp;
										<input
											type="text"
											class="form-control xsm"
											v-model="item.build_size_m2"
											@change="item.build_size_p = $m2_py_ex(item.build_size_m2)"
										/>
										&nbsp;㎡
									</td>
								</tr>
								<tr>
									<th>준공일자</th>
									<td>
										<input class="form-control" type="date" v-model="item.build_date" />
									</td>
									<th>용적률</th>
									<td>
										<input type="number" class="form-control sm" v-model="item.fa_ratio" />
										<span class="text">%</span>
									</td>
								</tr>
								<tr>
									<th>리모델링일자</th>
									<td>
										<input class="form-control" type="date" v-model="item.remodel_date" />
									</td>
									<th>규모(층)</th>
									<td>
										<input type="number" class="form-control xsm" v-model="item.floor_cnt_B" />
										<span class="text">층/</span>
										<input type="number" class="form-control xsm" v-model="item.floor_cnt_F" />
										<span class="text">층</span>
									</td>
								</tr>
								<tr>
									<th>주용도</th>
									<td><input type="text" class="form-control" v-model="item.main_purpose" /></td>
									<th>구조</th>
									<td>
										<select v-model="item.structure_uid" class="form-control select">
											<option value="" selected>선택</option>
											<option
												v-for="c in typeList.structure"
												:key="'struclist_' + c.ind_cfg_uid"
												:value="c.ind_cfg_uid"
											>
												{{ c.cfg_val1 }}
											</option>
										</select>
									</td>
								</tr>
								<tr>
									<th>냉/난방</th>
									<td>
										<select v-model="item.heat_type_uid" class="form-control select">
											<option value="" selected>선택</option>
											<option
												v-for="c in typeList.heat_type"
												:key="'heat_type_' + c.ind_cfg_uid"
												:value="c.ind_cfg_uid"
											>
												{{ c.cfg_val1 }}
											</option>
										</select>
									</td>
									<th>승강기</th>
									<td>
										<input type="number" class="form-control xsm" v-model="item.ev_cnt" />
										<span class="text">대</span>
									</td>
								</tr>
								<tr>
									<th>주차방식</th>
									<td>
										<select v-model="item.park_type_uid" class="form-control select">
											<option value="" selected>선택</option>
											<option v-for="c in typeList.park_type" :key="'park_type' + c.ind_cfg_uid" :value="c.ind_cfg_uid">
												{{ c.cfg_val1 }}
											</option>
										</select>
									</td>
									<th>주차대수</th>
									<td>
										<span class="text">법정</span>
										<input type="number" class="form-control xsm" v-model="item.park_cnt_law" />
										<span class="text">대</span>
										<br />
										<span class="text">실제</span>
										<input type="number" class="form-control xsm" v-model="item.park_cnt_real" />
										<span class="text">대</span>
									</td>
								</tr>
								<tr>
									<th>건물가격평당</th>
									<td>
										<money3
											class="form-control sm"
											v-model="item.building_price_py_price"
											v-bind="$MONEY1"
											@change="onUpdateData()"
										></money3>
										<span class="text">만</span>
									</td>
									<th>건물가격</th>
									<td>
										<money3
											class="form-control sm"
											v-model="item.building_price"
											v-bind="$MONEY1"
											@change="onUpdateData()"
											readonly
										></money3>
										<span class="text">만</span>
									</td>
								</tr>
							</table>
						</div>
					</div>
					<div class="right type2">
						<div class="con">
							<div class="left">
								<div class="con">
									<div class="tab-btn">
										<button type="button" class="btn tab" v-bind:class="{ active: menu1 == 0 }" @click="menu1 = 0">
											소유자정보
										</button>
										<button type="button" class="btn tab" v-bind:class="{ active: menu1 == 1 }" @click="menu1 = 1">
											전건물주
										</button>
										<button type="button" class="btn tab" v-bind:class="{ active: menu1 == 2 }" @click="menu1 = 2">
											메모
										</button>
									</div>
									<div v-if="menu1 == 0" class="tab-con">
										<table class="table type-input">
											<tr>
												<th>성명</th>
												<td>
													<input type="text" class="form-control" v-model="item.owner_name" ref="owner_name" maxlength="100" />
												</td>
											</tr>
											<tr>
												<th>연락처</th>
												<td>
													<template v-if="memType">
														<input
															type="tel"
															class="form-control sm"
															v-model="item.owner_home_phone"
															ref="owner_home_phone"
															@keyup="getPhoneMask(item.owner_home_phone, 'owner_home_phone')"
														maxlength="50"
														/>&nbsp;
														<input type="text" class="form-control sm" v-model="item.owner_home_phone_memo" maxlength="50" />
													</template>
													<template v-else>
														<input type="text" class="form-control sm" ref="owner_home_phone" disabled />&nbsp;
														<input type="text" class="form-control sm" disabled />
													</template>
												</td>
											</tr>
											<tr>
												<th>연락처</th>
												<td>
													<template v-if="memType">
														<input
															type="tel"
															class="form-control sm"
															v-model="item.owner_office_phone"
															@keyup="getPhoneMask(item.owner_office_phone, 'owner_office_phone')"
														maxlength="50"
														/>&nbsp;
														<input type="text" class="form-control sm" v-model="item.owner_office_phone_memo" maxlength="50" />
													</template>
													<template v-else>
														<input type="text" class="form-control sm" disabled />&nbsp;
														<input type="text" class="form-control sm" disabled />
													</template>
												</td>
											</tr>
											<tr>
												<th>연락처</th>
												<td>
													<template v-if="memType">
														<input
															type="tel"
															class="form-control sm"
															v-model="item.owner_mobile_1"
															@keyup="getPhoneMask(item.owner_mobile_1, 'owner_mobile_1')"
														maxlength="50"
														/>&nbsp;
														<input type="text" class="form-control sm" v-model="item.owner_mobile_1_memo" maxlength="50" />
													</template>
													<template v-else>
														<input type="text" class="form-control sm" disabled />&nbsp;
														<input type="text" class="form-control sm" disabled />
													</template>
												</td>
											</tr>
										</table>
									</div>
									<div v-else-if="menu1 == 1" class="tab-con">
										<table class="table type-input">
											<tr>
												<th>성명</th>
												<td>
													<input type="text" class="form-control" v-model="item.pre_owner_name" maxlength="100" />
												</td>
											</tr>
											<tr>
												<th>연락처</th>
												<td>
													<template v-if="memType">
														<input
															type="tel"
															class="form-control sm"
															v-model="item.pre_owner_home_phone"
															@keyup="getPhoneMask(item.pre_owner_home_phone, 'pre_owner_home_phone')"
														maxlength="50"
														/>&nbsp;
														<input type="text" class="form-control sm" v-model="item.pre_owner_home_phone_memo" maxlength="50" />
													</template>
													<template v-else>
														<input type="text" class="form-control sm" ref="owner_home_phone" disabled />&nbsp;
														<input type="text" class="form-control sm" disabled />
													</template>
												</td>
											</tr>
											<tr>
												<th>연락처</th>
												<td>
													<template v-if="memType">
														<input
															type="tel"
															class="form-control sm"
															v-model="item.pre_owner_office_phone"
															@keyup="getPhoneMask(item.pre_owner_office_phone, 'pre_owner_office_phone')"
														maxlength="50"
														/>&nbsp;
														<input type="text" class="form-control sm" v-model="item.pre_owner_office_phone_memo" maxlength="50" />
													</template>
													<template v-else>
														<input type="text" class="form-control sm" disabled />&nbsp;
														<input type="text" class="form-control sm" disabled />
													</template>
												</td>
											</tr>
											<tr>
												<th>연락처</th>
												<td>
													<template v-if="memType">
														<input
															type="tel"
															class="form-control sm"
															v-model="item.pre_owner_mobile_1"
															@keyup="getPhoneMask(item.pre_owner_mobile_1, 'pre_owner_mobile_1')"
														maxlength="50"
														/>&nbsp;
														<input type="text" class="form-control sm" v-model="item.pre_owner_mobile_1_memo" maxlength="50" />
													</template>
													<template v-else>
														<input type="text" class="form-control sm" disabled />&nbsp;
														<input type="text" class="form-control sm" disabled />
													</template>
												</td>
											</tr>
										</table>
									</div>
									<div v-else-if="menu1 == 2" class="tab-con">
										<textarea class="form-control" rows="10" v-model="item.owner_memo"></textarea>
									</div>
								</div>
								<div class="con">
									<div class="tit">금액정보</div>
									<table class="table type-input">
										<tr>
											<th>보증금</th>
											<td>
												<money3
													class="form-control sm"
													v-model="item.deposit"
													v-bind="$MONEY1"
													ref="deposit"
													@change="onUpdateData2()"
												></money3>
												<span class="text">만</span>
											</td>
											<th>전용면적</th>
											<td>
												<money3
													class="form-control sm"
													v-model="item.net_area_m2"
													v-bind="$MONEY2"
													ref="deposit"
													@change="onUpdateData2()"
												></money3>
												<span class="text">㎡</span>
											</td>
										</tr>
										<tr>
											<th>월임대료</th>
											<td>
												<money3
													class="form-control sm"
													v-model="item.monthly_rent"
													v-bind="$MONEY1"
													ref="deposit"
													@change="onUpdateData2()"
												></money3>
												<span class="text">만</span>
											</td>
											<th>전용률</th>
											<td>
												<money3
													class="form-control sm"
													v-model="item.ex_rate"
													v-bind="$MONEY2"
													ref="deposit"
													disabled
												></money3>
												<span class="text">%</span>
											</td>
										</tr>
										<tr>
											<th>관리비</th>
											<td>
												<money3
													class="form-control sm"
													v-model="item.main_fee"
													v-bind="$MONEY1"
													ref="deposit"
													@change="onUpdateData2()"
												></money3>
												<span class="text">만</span>
											</td>
											<th>월고정비</th>
											<td>
												<money3
													class="form-control sm"
													v-model="item.monthly_fixed"
													v-bind="$MONEY1"
													ref="deposit"
												></money3>
												<span class="text">만</span>
											</td>
										</tr>
										<tr>
											<th>층 정보</th>
											<td>
												<input type="text" class="form-control sm" v-model="item.floor_info" />
											</td>
											<th>무료/유료 주차</th>
											<td>
												<input type="text" class="form-control xsm" v-model="item.free_parking" />
												<span class="text">대</span>
												<span class="text"></span>
												<input type="text" class="form-control xsm" v-model="item.fee_paring" />
												<span class="text">대</span>
											</td>
										</tr>
										<tr>
											<th>입주현황</th>
											<td>
												<input type="text" class="form-control sm" v-model="item.in_status" />
											</td>
											<th>화장실유형</th>
											<td>
												<input type="text" class="form-control sm" v-model="item.bathroom_type" />
											</td>
										</tr>
										<tr>
											<th>임대면적</th>
											<td>
												<money3
													class="form-control sm"
													v-model="item.rent_area_m2"
													v-bind="$MONEY2"
													ref="deposit"
													@change="onUpdateData2()"
												></money3>
												<span class="text">㎡</span>
											</td>
											<th>평당 임대료</th>
											<td>
												<money3
													class="form-control sm"
													v-model="item.rent_py_price"
													v-bind="$MONEY2"
													ref="deposit"
													disabled
												></money3>
												<span class="text">만</span>
											</td>
										</tr>
										<tr>
											<th>인테리어</th>
											<td>
												<label class="input-checkbox">
													<input type="radio" name="interior" value="need" v-model="item.interior_type" />
													<span class="checkbox radio"></span>
													<span class="text">필요</span>
												</label>
												<label class="input-checkbox">
													<input type="radio" name="interior" value="good" v-model="item.interior_type" />
													<span class="checkbox radio"></span>
													<span class="text">양호</span>
												</label>
												<label class="input-checkbox">
													<input type="radio" name="interior" value="demo" v-model="item.interior_type" />
													<span class="checkbox radio"></span>
													<span class="text">철거완료</span>
												</label>
											</td>
											<th>렌트프리</th>
											<td>
												<label class="input-checkbox">
													<input type="radio" name="rent_free" value="none" v-model="item.rent_free" />
													<span class="checkbox radio"></span>
													<span class="text">협의</span>
												</label>
												<label class="input-checkbox">
													<input type="radio" name="rent_free" value="confer" v-model="item.rent_free" />
													<span class="checkbox radio"></span>
													<span class="text">0개월</span>
												</label>
												<br />
												<label class="input-checkbox">
													<input type="radio" name="rent_free" value="selet" v-model="item.rent_free" />
													<span class="checkbox radio"></span>
												</label>
												<input type="text" class="form-control xsm mt-1" v-model="item.rent_free_month" />
												<span class="text">개월</span>
											</td>
										</tr>
									</table>
								</div>
							</div>
							<div class="right">
								<div class="con work-history-panel">
									<div class="tab-btn">
										<button
											type="button"
											class="btn tab"
											v-bind:class="{ active: menu2 == false }"
											@click="menu2 = false"
										>
											작업내역
										</button>
										<button
											type="button"
											class="btn tab"
											v-bind:class="{ active: menu2 == true }"
											@click="menu2 = true"
										>
											변경내역
										</button>
									</div>
									<div class="tab-con">
										<div v-if="menu2 == false" class="tab-con">
											<div class="input-top">
												<select v-model="searchOptions.type" class="form-control select">
													<option
														v-for="c in clientTypeList"
														:key="'clienttype_' + c.ind_cfg_uid"
														:value="c.ind_cfg_uid"
													>
														{{ c.name }}
													</option>
												</select>
												<input
													type="text"
													class="form-control"
													v-model="searchOptions.keyword"
													@keyup.enter="addClientLog"
												/>
											</div>
											<table class="table type-input">
												<colgroup>
													<col width="35%" />
													<col width="65%" />
												</colgroup>
												<tr>
													<th>일시</th>
													<th>구분</th>
													<th>작업자</th>
												</tr>
												<!-- 작업시작·담당자 변경·고객상담을 날짜 내림차순으로 통합 렌더 -->
												<template v-for="entry in combinedWorkList" :key="entry.key">
													<template v-if="entry.kind === 'work'">
														<tr class="work-row">
															<td>
																<strong>
																	{{ $dateToFormat(entry.date, 'YYYY-MM-DD') }}
																	<span style="color: #65af7e">{{ $dateToFormat(entry.date, 'ddd') }}</span>
																	{{ $dateToFormat(entry.date, 'hh:mm') }}
																</strong>
															</td>
															<td>{{ entry.label }}</td>
															<td>{{ entry.doer }}</td>
														</tr>
														<tr class="work-row">
															<td colspan="3">{{ entry.desc }}</td>
														</tr>
													</template>
													<template v-else-if="entry.kind === 'client'">
														<tr>
															<td>
																<strong>
																	{{ $dateToFormat(entry.date, 'YYYY-MM-DD') }}
																	<span style="color: #65af7e">{{ $dateToFormat(entry.date, 'ddd') }}</span>
																	{{ $dateToFormat(entry.date, 'hh:mm') }}
																</strong>
															</td>
															<td>{{ entry.log.counsel_type_name }}</td>
															<td>{{ entry.log.mem_name }}</td>
														</tr>
														<tr>
															<td colspan="3">
																{{ entry.log.memo }}
																<button type="button" class="btn icon red" @click="btnClientLogDel(entry.log.client_log_uid)">
																	<b-icon-trash />
																</button>
															</td>
														</tr>
													</template>
												</template>
											</table>
										</div>
										<div v-else class="tab-con">
											<table class="table type-input">
												<colgroup>
													<col width="35%" />
													<col width="65%" />
												</colgroup>
												<tr>
													<th>일시</th>
													<th>구분</th>
													<th>작업자</th>
												</tr>
												<template :key="'mgrlog_' + log.mgr_log_uid" v-for="log in filteredMgrLogList">
													<tr :class="{ 'work-row': log.sub_type_key === 'building_mem_uid' }">
														<td>
															<strong>
																{{ $dateToFormat(log.date, 'YYYY-MM-DD') }}
																<span style="color: #65af7e">{{ $dateToFormat(log.date, 'ddd') }}</span>
																{{ $dateToFormat(log.date, 'hh:mm') }}
															</strong>
														</td>
														<td>{{ $LOG_CHG_INFO[log.sub_type_key] }}</td>
														<td>{{ log.mem_name }}</td>
													</tr>
													<tr :class="{ 'work-row': log.sub_type_key === 'building_mem_uid' }">
														<td colspan="3">
															{{ log.memo }}
															<button type="button" class="btn icon red" @click="btnMgrLogDel(log.mgr_log_uid)">
																<b-icon-trash />
															</button>
														</td>
													</tr>
												</template>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="center type2">
							<div class="con">
								<div class="tab-btn">
									<button type="button" class="btn tab" v-bind:class="{ active: menu3 == 0 }" @click="menu3 = 0">
										임대차내역
									</button>
									<button type="button" class="btn tab" v-bind:class="{ active: menu3 == 1 }" @click="menu3 = 1">
										건축물대장
									</button>
									<button type="button" class="btn tab" v-bind:class="{ active: menu3 == 2 }" @click="menu3 = 2">
										특징
									</button>
								</div>
								<div class="tab-con" v-if="menu3 == 0">
									<table class="table type-input">
										<colgroup>
											<col width="auto" />
											<col width="auto" />
											<col width="auto" />
											<col width="auto" />
											<col width="auto" />
											<col width="auto" />
											<col width="auto" />
											<col width="auto" />
											<col width="20%" />
											<col width="auto" />
											<col width="auto" />
										</colgroup>
										<tr>
											<th></th>
											<th>층</th>
											<th>임대</th>
											<th>용도</th>
											<th>보증금</th>
											<th>월세</th>
											<th>관리비</th>
											<th>만기</th>
											<th>비고</th>
											<th>제외</th>
											<th>평당임대료</th>
										</tr>
										<draggable v-model="rentList" tag="tbody" item-key="building_rent_uid" @end="onEnd" handle=".ttg">
											<template #item="{ element }">
												<tr :class="{ 'rent-excluded': element.except_flag === 'Y' }">
													<td class="ttg">
														<b-icon-arrows-expand />
													</td>
													<td class="text-center">
														<input
															type="text"
															class="form-control"
															v-model="element.rent_floor"
															@change="onUpdateData()"
															@keyup.enter="addFloorTable"
														/>
													</td>
													<td class="text-center">
														<money3
															class="form-control"
															v-model="element.rent_size_p"
															v-bind="$MONEY2"
															@change="onUpdateData()"
															@keyup.enter="addFloorTable"
														></money3>
													</td>
													<td class="text-center">
														<input
															type="text"
															class="form-control"
															v-model="element.rent_usage"
															@change="onUpdateData()"
															@keyup.enter="addFloorTable"
														/>
													</td>
													<td class="text-center">
														<money3
															class="form-control"
															v-model="element.rent_deposit"
															v-bind="$MONEY1"
															@change="onUpdateData()"
															@keyup.enter="addFloorTable"
														></money3>
													</td>
													<td class="text-center">
														<money3
															class="form-control"
															v-model="element.rent_money"
															v-bind="$MONEY1"
															@change="onUpdateData()"
															@keyup.enter="addFloorTable"
														></money3>
													</td>
													<td class="text-center">
														<money3
															class="form-control"
															v-model="element.mgr_fee"
															v-bind="$MONEY1"
															@change="onUpdateData()"
															@keyup.enter="addFloorTable"
														></money3>
													</td>
													<td class="text-center">
														<input
															type="text"
															class="form-control"
															v-model="element.end_date"
															@change="onUpdateData()"
															@keyup.enter="addFloorTable"
														/>
													</td>
													<td class="text-center">
														<input
															type="text"
															class="form-control"
															v-model="element.memo"
															@change="onUpdateData()"
															@keyup.enter="addFloorTable"
														/>
													</td>
													<td class="text-center">
														<label class="input-checkbox">
															<input
																type="checkbox"
																v-model="element.except_flag"
																true-value="Y"
																false-value="N"
																@change="onUpdateData()"
																@keyup.enter="addFloorTable"
															/>
															<span class="checkbox"></span>
														</label>
													</td>
													<td class="text-center">
														<money3 class="form-control" v-model="element.rent_ni" v-bind="$MONEY2" readonly></money3>
													</td>
												</tr>
											</template>
										</draggable>
									</table>

									<!-- <table class="table type-input">
										<colgroup>
											<col width="auto" />
											<col width="auto" />
											<col width="auto" />
											<col width="auto" />
											<col width="auto" />
											<col width="auto" />
											<col width="auto" />
											<col width="20%" />
											<col width="auto" />
											<col width="auto" />
										</colgroup>
										<tr>
											<th>층</th>
											<th>임대</th>
											<th>용도</th>
											<th>보증금</th>
											<th>월세</th>
											<th>관리비</th>
											<th>만기</th>
											<th>비고</th>
											<th>제외</th>
											<th>평당임대료</th>
										</tr>
										<tr>
											<td class="text-center"><input type="text" class="form-control" /></td>
											<td class="text-center"><input type="text" class="form-control" /></td>
											<td class="text-center"><input type="text" class="form-control" /></td>
											<td class="text-center"><input type="text" class="form-control" /></td>
											<td class="text-center"><input type="text" class="form-control" /></td>
											<td class="text-center"><input type="text" class="form-control" /></td>
											<td class="text-center"><input type="text" class="form-control" /></td>
											<td class="text-center"><input type="text" class="form-control" /></td>
											<td class="text-center">
												<label class="input-checkbox">
													<input type="checkbox" />
													<span class="checkbox"></span>
												</label>
											</td>
											<td class="text-center"><input type="text" class="form-control" /></td>
										</tr>
									</table> -->

									<table class="table type-input mt-5">
										<tr>
											<th rowspan="2">합계</th>
											<th>평</th>
											<th>보증금</th>
											<th>월세</th>
											<th>관리비</th>
											<th rowspan="2">월세+관리비</th>
											<td class="text-center" rowspan="2">{{ $formatNumber(totalData.money + totalData.mgr) }}</td>
										</tr>
										<tr>
											<td class="text-center">{{ $formatNumber(totalData.py) }}</td>
											<td class="text-center">{{ $formatNumber(totalData.deposit) }}</td>
											<td class="text-center">{{ $formatNumber(totalData.money) }}</td>
											<td class="text-center">{{ $formatNumber(totalData.mgr) }}</td>
										</tr>
									</table>
								</div>
								<div class="tab-con" v-else-if="menu3 == 1">
									<div class="mb-2">
										<button type="button" class="btn btn-xsm btn-secondary m-r--1" @click="isPopupShow3 = true">
											공용면적안분
										</button>
										<button type="button" class="btn btn-xsm btn-secondary" @click="isPopupShow4 = true">
											건폐율/용적률
										</button>
									</div>
									<table class="table type-input">
										<colgroup>
											<col width="10%" />
											<col width="10%" />
											<col width="10%" />
											<col width="20%" />
											<col width="auto" />
											<col width="5%" />
										</colgroup>
										<tr>
											<th>층</th>
											<th>면적</th>
											<th>평수</th>
											<th>주구조</th>
											<th>층별용도</th>
											<th>제외</th>
										</tr>
										<tr :key="'floor_' + floor.building_floor_uid" v-for="floor in floorList" :class="{ 'floor-excluded': floor.chk_except === 'Y' }">
											<td class="text-center">{{ floor.flrNoNm }}</td>
											<td class="text-center">{{ $formatArea(floor.area_m2) }}</td>
											<td class="text-center">{{ $formatArea(floor.area_py) }}</td>
											<td class="text-center">{{ floor.strctCdNm }}</td>
											<td class="text-center">{{ floor.name }}</td>
											<td class="text-center">
												<label class="input-checkbox">
													<input
														type="checkbox"
														v-model="floor.chk_except"
														true-value="Y"
														false-value="N"
														@change="onUpdateFloor(), onUpdateData()"
													/>
													<span class="checkbox"></span>
												</label>
											</td>
										</tr>
									</table>

									<table class="table type-input mt-5">
										<colgroup>
											<col width="20%" />
											<col width="40%" />
											<col width="40%" />
										</colgroup>
										<tr>
											<th rowspan="2">합계</th>
											<th>면적</th>
											<th>평수</th>
										</tr>
										<tr>
											<td class="text-center">{{ floorTotal.m2 }}</td>
											<td class="text-center">{{ floorTotal.py }}</td>
										</tr>
									</table>
								</div>
								<div class="tab-con" v-else-if="menu3 == 2">
									<textarea class="form-control" rows="15" v-model="item.memo"></textarea>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="isPopupShow1" class="popup-wrap">
			<div class="dim" @click="isPopupShow1 = false"></div>
			<div class="popup sm">
				<div class="popup-tit">
					연결물건등록
					<button type="button" class="btn btn-close" @click="isPopupShow1 = false"><b-icon-x-lg /></button>
				</div>
				<div class="popup-con">
					<div class="input-wrap">
						<input
							type="text"
							class="form-control"
							placeholder="물건명, 주소, 소유자, 전소유자, 전화번호"
							v-model="searchInfo.keyword"
							@keyup.enter="getBuildingList(1)"
						/>
						<button type="button" class="btn btn-sm btn-secondary" @click="getBuildingList(1)">검색</button>
					</div>
					<div class="table-wrap mt-3">
						<span class="txt-c--red">※ 검색물건목록</span>
						<table class="table mt-2 click">
							<tr>
								<th>물건번호</th>
								<th>상태</th>
								<th>물건명/주소</th>
								<th>삭제</th>
							</tr>
							<tr v-for="b in buildingList" :key="'bubu_' + b.bid">
								<td>{{ b.bid }}</td>
								<td>{{ $ITEM_STATE[b.state] }}</td>
								<td>{{ b.building_name }} / {{ b.jibun_addr }}</td>
								<td>
									<button type="button" class="btn btn-xsm txt-c--blue" @click="btnOnLinkAdd(b.bid)">
										<b-icon-plus-circle />
									</button>
								</td>
							</tr>
						</table>
					</div>
					<ul
						class="pagination b-pagination pagination-sm"
						v-if="buildingPage.pageData != null && buildingPage.pageData.list.length"
					>
						<li class="page-item" v-bind:class="{ disabled: 1 == buildingPage.page }">
							<button type="button" class="page-link" @click="getBuildingList(1)">
								<b-icon-chevron-double-left />
							</button>
						</li>

						<li class="page-item" v-bind:class="{ disabled: buildingPage.pageData.first == null }">
							<button
								type="button"
								class="page-link"
								@click="buildingPage.pageData.first !== null ? getBuildingList(buildingPage.pageData.first) : ''"
							>
								<b-icon-chevron-left />
							</button>
						</li>
						<li
							v-for="pg in buildingPage.pageData.list"
							v-bind:key="'pg_' + pg"
							class="page-item"
							v-bind:class="{ active: buildingPage.pageData.currentPage == pg }"
						>
							<button type="button" class="page-link" @click="getBuildingList(pg)">{{ pg }}</button>
						</li>
						<li class="page-item" v-bind:class="{ disabled: buildingPage.pageData.end == null }">
							<button
								type="button"
								class="page-link"
								@click="buildingPage.pageData.end !== null ? getBuildingList(buildingPage.pageData.end) : ''"
							>
								<b-icon-chevron-right />
							</button>
						</li>

						<li class="page-item" v-bind:class="{ disabled: buildingPage.pageData.totalPage == buildingPage.page }">
							<button type="button" class="page-link" @click="getBuildingList(buildingPage.pageData.totalPage)">
								<b-icon-chevron-double-right />
							</button>
						</li>
					</ul>
					<div class="table-wrap mt-3">
						<span class="txt-c--red">※ 연결물건목록</span>
						<table class="table mt-2 click">
							<tr>
								<th>물건번호</th>
								<th>상태</th>
								<th>물건명/주소</th>
								<th>삭제</th>
							</tr>
							<tr v-for="(b, idx) in linkList" :key="'bububu_' + b.bid">
								<td>{{ idx + 1 }}</td>
								<td>{{ $ITEM_STATE[b.state] }}</td>
								<td>{{ b.building_name }} / {{ b.jibun_addr }}</td>
								<td>
									<button type="button" class="btn btn-xsm txt-c--red" @click="btnOnLinkDel(b.bid)">
										<b-icon-trash />
									</button>
								</td>
							</tr>
						</table>
					</div>
					<div class="btn-wrap mt-3">
						<button type="button" class="btn btn-md btn-primary" @click="isPopupShow1 = false">확인</button>
					</div>
				</div>
			</div>
		</div>
		<div v-if="isPopupShow2" class="popup-wrap">
			<div class="dim" @click="isPopupShow2 = false"></div>
			<div class="popup sm">
				<div class="popup-tit">
					첨부파일
					<button type="button" class="btn btn-close" @click="isPopupShow2 = false"><b-icon-x-lg /></button>
				</div>
				<div class="popup-con">
					<table class="table type-input mb-2">
						<tr>
							<th>신규</th>
							<td>
								<div class="row">
									<div class="col-6">
										<input type="text" class="form-control" v-model="fileName" />
									</div>
									<div class="col-6 d-flex align-items-center pl-0">
										<input type="file" class="" @change="fileFile($event)" />
									</div>
								</div>
							</td>
							<td>
								<button type="button" class="btn btn-xsm btn-secondary" @click="onFileSave" :disabled="fileUploading">{{ fileUploading ? '업로드 중...' : '등록' }}</button>
							</td>
						</tr>
					</table>
					<table class="table">
						<colgroup>
							<col width="10%" />
							<col width="40%" />
							<col width="40%" />
							<col width="10%" />
						</colgroup>
						<tr>
							<th>번호</th>
							<th>파일명</th>
							<th>다운로드</th>
							<th>삭제</th>
						</tr>
						<tr v-for="(f, idx) in fileList" :key="'fff_' + f.id">
							<td>{{ idx + 1 }}</td>
							<td>
								<input type="text" class="form-control" v-model="f.usr_name" @keyup.enter="saveFileName(f)" />
							</td>
							<td>
								<button type="button" class="btn btn-xsm btn-light" @click="downFile(f.id, f)">
									<b-icon-download />{{ f.org_name }}
								</button>
							</td>
							<td>
								<button type="button" class="btn btn-xsm txt-c--red" @click="delFile(f.id, idx)">
									<b-icon-trash />
								</button>
							</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
		<div v-if="isPopupShow3" class="popup-wrap">
			<div class="dim" @click="isPopupShow3 = false"></div>
			<div class="popup sm">
				<div class="popup-tit">
					공용면적안분
					<button type="button" class="btn btn-close" @click="isPopupShow3 = false"><b-icon-x-lg /></button>
				</div>
				<div class="popup-con" style="max-height: 900px; overflow: auto">
					<div class="popup-con">
						<table class="table">
							<tr>
								<th>층</th>
								<th>면적</th>
								<th>평수</th>
								<th>선택</th>
								<th>제외</th>
								<th>층별용도</th>
							</tr>
							<tr :key="'floor2_' + floor.building_floor_uid" v-for="floor in floorList" :class="{ 'floor-excluded': floor.chk_except === 'Y' }">
								<td>{{ floor.flrNoNm }}</td>
								<td>{{ $formatArea(floor.area_m2) }}</td>
								<td>{{ $formatArea(floor.area_py) }}</td>
								<td>
									<label class="input-checkbox">
										<input
											v-if="floor.chk_except == 'N'"
											type="checkbox"
											v-model="floor.chk_pa"
											true-value="Y"
											false-value="N"
											@change="onUpdateData"
										/>
										<span v-if="floor.chk_except == 'N'" class="checkbox"></span>
									</label>
								</td>
								<td>
									<label class="input-checkbox">
										<input
											type="checkbox"
											v-model="floor.chk_except"
											true-value="Y"
											false-value="N"
											@change="onUpdateData"
										/>
										<span class="checkbox"></span>
									</label>
								</td>
								<td>{{ floor.name }}</td>
							</tr>
						</table>
						<table class="table type-input mt-5 mb-1">
							<colgroup>
								<col width="15%" />
								<col width="25%" />
								<col width="25%" />
								<col width="10%" />
								<col width="10%" />
								<col width="35%" />
							</colgroup>
							<tr>
								<th>공용면적 합계</th>
								<td>
									<input type="text" class="form-control" v-model="sum_deposit_m2" readonly />
								</td>
								<td>
									<input type="text" class="form-control" v-model="sum_deposit_py" readonly />
								</td>
								<td>{{ chk_cnt }}</td>
								<td></td>
								<td></td>
							</tr>
						</table>
						<table class="table type-input">
							<tr>
								<th rowspan="2">층</th>
								<th rowspan="2">전용(㎡)</th>
								<th rowspan="2">전용(평)</th>
								<th rowspan="2">비율(%)</th>
								<th colspan="2">공용면적안분</th>
								<th rowspan="2">임대평수</th>
							</tr>
							<tr>
								<th>㎡</th>
								<th>평</th>
							</tr>
							<tr v-for="fg in floorGroup" :key="'fg_' + fg.flrNoNm">
								<td>{{ fg.flrNoNm }}</td>
								<td>
									<input type="text" class="form-control" v-model="fg.area_m2" readonly />
								</td>
								<td>
									<input type="text" class="form-control" v-model="fg.area_py" readonly />
								</td>

								<td>
									<input type="text" class="form-control" v-model="fg.pa_rate" readonly />
								</td>
								<td>
									<input type="text" class="form-control" v-model="fg.divide_m2" readonly />
								</td>
								<td>
									<input type="text" class="form-control" v-model="fg.divide_py" readonly />
								</td>
								<td>
									<input type="text" class="form-control" v-model="fg.rent_py" readonly />
								</td>
							</tr>
						</table>
						<div class="btn-wrap mt-3">
							<button type="button" class="btn btn-md btn-secondary" @click="isPopupShow3 = false">취소</button>
							<button type="button" class="btn btn-md btn-primary" @click="btnSaveFloor">저장</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="isPopupShow4" class="popup-wrap">
			<div class="dim" @click="isPopupShow4 = false"></div>
			<div class="popup sm">
				<div class="popup-tit">
					건폐율/용적률
					<button type="button" class="btn btn-close" @click="isPopupShow4 = false"><b-icon-x-lg /></button>
				</div>
				<div class="popup-con">
					<div class="popup-con">
						<p class="mb-2" data-testid="rate-register-note">
							지금 값: 건폐율 {{ (item && item.bl_ratio) || 0 }}% / 용적률 {{ (item && item.fa_ratio) || 0 }}%. 건축물대장에 값이 있으면
							대장 값이 원칙입니다. 이 계산은 대장에 값이 없을 때 참고용이며, 고른 층이 있는 칸만 바꿉니다.
						</p>
						<table class="table" data-testid="rate-floor-table">
							<tr>
								<th>면적</th>
								<th>평수</th>
								<th>층별용도</th>
								<th>제외</th>
								<th>건폐율 대상 선택</th>
								<th>용적률 제외 선택</th>
							</tr>
							<tr
								:key="'rate_floor_' + floor.building_floor_uid"
								v-for="floor in floorList"
								:data-floor-uid="floor.building_floor_uid"
								:class="{ 'floor-excluded': floor.chk_except === 'Y' }"
							>
								<td class="text-center">{{ $formatArea(floor.area_m2) }}</td>
								<td class="text-center">{{ $formatArea(floor.area_py) }}</td>
								<td class="text-center">{{ floor.name }}</td>
								<td class="text-center">
									<label class="input-checkbox">
										<input
											type="checkbox"
											v-model="floor.chk_except"
											true-value="Y"
											false-value="N"
											@change="onUpdateFloor(), onUpdateData()"
											data-testid="rate-chk-except"
										/>
										<span class="checkbox"></span>
									</label>
								</td>
								<td class="text-center">
									<label class="input-checkbox">
										<input
											type="checkbox"
											:value="floor.building_floor_uid"
											v-model="blRatioTargetIds"
											data-testid="rate-chk-bl"
										/>
										<span class="checkbox"></span>
									</label>
								</td>
								<td class="text-center">
									<label class="input-checkbox">
										<input
											type="checkbox"
											:value="floor.building_floor_uid"
											v-model="faRatioExcludeIds"
											data-testid="rate-chk-fa"
										/>
										<span class="checkbox"></span>
									</label>
								</td>
							</tr>
						</table>
						<table class="table type-input mt-3">
							<tr>
								<th>대지면적</th>
								<td data-testid="rate-land-size">{{ $formatArea(item && item.land_size_m2) }}㎡</td>
								<th>연면적</th>
								<td data-testid="rate-total-size">{{ $formatArea(item && item.total_size_m2) }}㎡</td>
							</tr>
							<tr>
								<th>건폐율</th>
								<td data-testid="rate-bl-ratio">{{ calcBlRatio }}%</td>
								<th>용적률</th>
								<td data-testid="rate-fa-ratio">{{ calcFaRatio }}%</td>
							</tr>
							<tr>
								<th>건폐율대상면적</th>
								<td data-testid="rate-bl-target">{{ $formatArea(blRatioTargetArea) }}㎡</td>
								<th>용적률대상면적</th>
								<td data-testid="rate-fa-target">{{ $formatArea(faRatioTargetArea) }}㎡</td>
							</tr>
						</table>
						<div class="btn-wrap mt-3">
							<button type="button" class="btn btn-md btn-secondary" @click="cancelBlFaRatio">닫기</button>
							<button type="button" class="btn btn-md btn-primary" @click="applyBlFaRatio" data-testid="rate-apply">적용</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="isPopupShow5" class="popup-wrap">
			<div class="dim" @click="isPopupShow5 = false"></div>
			<div class="popup md">
				<div class="popup-tit">
					연결물건합계
					<button type="button" class="btn btn-close" @click="isPopupShow5 = false"><b-icon-x-lg /></button>
				</div>
				<div class="popup-con">
					<div class="popup-con">
						<table class="table">
							<colgroup>
								<col width="8%" />
								<col width="12%" />
								<col width="30%" />
								<col width="30%" />
								<col width="20%" />
							</colgroup>
							<tr>
								<th colspan="2">물건명</th>
								<th v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">{{ it.building_name }}</th>
								<th rowspan="2">합계</th>
							</tr>
							<tr>
								<th colspan="2">주소</th>
								<th v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">{{ it.jibun_addr }}</th>
							</tr>
							<tr>
								<th rowspan="11">금액정보</th>
								<th>월임대료</th>
								<td class="txt-c--red" v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatMoney(Number(it.monthly_rent), $MONEY_FORMAT_TYPE.LOAN) }}
								</td>
								<td class="bg-blue txt-c--red">
									{{ $formatMoney(linkSumObj.sum_monthly_rent, $MONEY_FORMAT_TYPE.LOAN) }}
								</td>
							</tr>
							<tr>
								<th>보증금</th>
								<td class="txt-c--red" v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatMoney(Number(it.deposit), $MONEY_FORMAT_TYPE.LOAN) }}
								</td>
								<td class="bg-blue txt-c--red">
									{{ $formatMoney(linkSumObj.sum_deposit, $MONEY_FORMAT_TYPE.LOAN) }}
								</td>
							</tr>
							<tr>
								<th>관리비</th>
								<td class="txt-c--red" v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatMoney(Number(it.main_fee), $MONEY_FORMAT_TYPE.LOAN) }}
								</td>
								<td class="bg-blue txt-c--red">
									{{ $formatMoney(linkSumObj.sum_main_fee, $MONEY_FORMAT_TYPE.LOAN) }}
								</td>
							</tr>
							<tr>
								<th>월고정비</th>
								<td class="txt-c--red" v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatMoney(Number(it.monthly_fixed), $MONEY_FORMAT_TYPE.LOAN) }}
								</td>
								<td class="bg-blue txt-c--red">
									{{ $formatMoney(linkSumObj.sum_monthly_fixed, $MONEY_FORMAT_TYPE.LOAN) }}
								</td>
							</tr>
							<tr>
								<th>임대면적</th>
								<td v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatArea(it.rent_area_m2) }}㎡ <strong>[{{ $formatArea(it.rent_area_py) }}평]</strong>
								</td>
								<td class="bg-blue">
									{{ $formatArea(linkSumObj.sum_rent_area_m2) }}㎡
									<strong>[{{ $formatArea(linkSumObj.sum_rent_area_py) }}평]</strong>
								</td>
							</tr>
							<tr>
								<th>평당 임대료</th>
								<td v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatMoney(Number(it.rent_py_price), $MONEY_FORMAT_TYPE.LOAN) }}
								</td>
								<td class="bg-blue">
									{{ $formatMoney(linkSumObj.sum_rent_py_price, $MONEY_FORMAT_TYPE.LOAN) }}
								</td>
							</tr>
							<tr>
								<th>전용면적</th>
								<td v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatArea(it.net_area_m2) }}㎡ <strong>[{{ $formatArea(it.net_area_py) }}평]</strong>
								</td>
								<td class="bg-blue">
									{{ $formatArea(linkSumObj.sum_net_area_m2) }}㎡
									<strong>[{{ $formatArea(linkSumObj.sum_net_area_py) }}평]</strong>
								</td>
							</tr>
							<tr>
								<th>전용률</th>
								<td v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">{{ it.ex_rate }}%</td>
								<td class="bg-blue">{{ linkSumObj.sum_ex_rate }}%</td>
							</tr>

							<tr>
								<th>토지가격</th>
								<td v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatMoney(Number(it.land_price), $MONEY_FORMAT_TYPE.LOAN) }}(평당
									{{ $formatMoney(Number(it.land_size_py_price), $MONEY_FORMAT_TYPE.LOAN) }})
								</td>
								<td class="bg-blue">
									{{ $formatMoney(linkSumObj.sum_land_price, $MONEY_FORMAT_TYPE.LOAN) }}(평당
									{{ $formatMoney(linkSumObj.sum_land_size_py_price, $MONEY_FORMAT_TYPE.LOAN) }})
								</td>
							</tr>
							<tr>
								<th>건물가격</th>
								<td v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatMoney(Number(it.building_price), $MONEY_FORMAT_TYPE.LOAN) }}(평당
									{{ $formatMoney(Number(it.building_price_py_price), $MONEY_FORMAT_TYPE.LOAN) }})
								</td>
								<td class="bg-blue">
									{{ $formatMoney(linkSumObj.sum_building_price, $MONEY_FORMAT_TYPE.LOAN) }}(평당
									{{ $formatMoney(linkSumObj.sum_building_price_py_price, $MONEY_FORMAT_TYPE.LOAN) }})
								</td>
							</tr>
							<tr>
								<th>연면적평당가격</th>
								<td v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatMoney(Number(it.total_size_py_price), $MONEY_FORMAT_TYPE.LOAN) }}
								</td>
								<td class="bg-blue">{{ $formatMoney(linkSumObj.sum_total_size_py_price, $MONEY_FORMAT_TYPE.LOAN) }}</td>
							</tr>

							<tr>
								<th rowspan="2">토지정보</th>
								<th>대지면적</th>
								<td v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatArea(it.land_size_m2) }}㎡ <strong>[{{ $formatArea(it.land_size_p) }}평]</strong>
								</td>
								<td class="bg-blue">
									{{ $formatArea(linkSumObj.sum_land_size_m2) }}㎡
									<strong>[{{ $formatArea(linkSumObj.sum_land_size_p) }}평]</strong>
								</td>
							</tr>
							<tr>
								<th>공시지가합계</th>
								<td v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatMoney(Number(it.public_land_price), $MONEY_FORMAT_TYPE.LOAN) }}(평당
									{{ $formatMoney(Number(it.public_land_price_py_price), $MONEY_FORMAT_TYPE.LOAN) }})
								</td>
								<td class="bg-blue">
									{{ $formatMoney(linkSumObj.sum_public_land_price, $MONEY_FORMAT_TYPE.LOAN) }}(평당
									{{ $formatMoney(linkSumObj.sum_public_land_price_py_price, $MONEY_FORMAT_TYPE.LOAN) }})
								</td>
							</tr>
							<tr>
								<th rowspan="2">건축물정보</th>
								<th>연면적</th>
								<td v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatArea(it.total_size_m2) }}㎡ <strong>[{{ $formatArea(it.total_size_p) }}평]</strong>
								</td>
								<td class="bg-blue">
									{{ $formatArea(linkSumObj.sum_total_size_m2) }}㎡
									<strong>[{{ $formatArea(linkSumObj.sum_total_size_p) }}평]</strong>
								</td>
							</tr>
							<tr>
								<th>건축면적</th>
								<td v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatArea(it.build_size_m2) }}㎡ <strong>[{{ $formatArea(it.build_size_p) }}평]</strong>
								</td>
								<td class="bg-blue">
									{{ $formatArea(linkSumObj.sum_build_size_m2) }}㎡
									<strong>[{{ $formatArea(linkSumObj.sum_build_size_p) }}평]</strong>
								</td>
							</tr>
						</table>
						<div class="btn-wrap mt-3">
							<button type="button" class="btn btn-md btn-primary" @click="isPopupShow5 = false">확인</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-show="isPopupShow6" class="popup-wrap">
			<div class="dim" @click="isPopupShow6 = false"></div>
			<div class="popup md">
				<div class="popup-tit">
					연결주소등록
					<button type="button" class="btn btn-close" @click="isPopupShow6 = false"><b-icon-x-lg /></button>
				</div>
				<div class="popup-con">
					<div class="search-top mb-2">
						<div class="left">
							<label class="input-label">주소입력</label>

							<input type="text" class="form-control" placeholder="주소" v-model="adr" @keyup.enter="searchAddress" />
							<button type="button" class="btn btn-primary btn-sm" @click="searchAddress">검색</button>
							<button type="button" class="btn btn-success btn-sm" @click="btnOnStage">추가</button>
						</div>
						<div class="right"></div>
					</div>
					<table class="table type-input">
						<colgroup>
							<col width="20%" />
							<col width="80%" />
						</colgroup>
						<tr>
							<th>도로명주소</th>
							<td>{{ roadAddress }}</td>
						</tr>
						<tr>
							<th>지번주소</th>
							<td>{{ jibunAddress }}</td>
						</tr>
					</table>

					<div class="map sm mt-2"><div id="createMap"></div></div>
					<div v-if="stagedAddresses.length" class="txt-c--blue mt-2 mb-1">※ 등록 대기 목록 ({{ stagedAddresses.length }}건)</div>
					<div v-if="stagedAddresses.length" class="table-wrap" style="max-height: 15vh">
						<table class="table sm">
							<tr class="sticky">
								<th>도로명주소</th>
								<th>지번주소</th>
								<th>삭제</th>
							</tr>
							<tr v-for="(staged, idx) in stagedAddresses" :key="'staged_' + idx">
								<td>{{ staged.road_addr }}</td>
								<td>{{ staged.jibun_addr }}</td>
								<td>
									<button type="button" class="btn btn-xsm txt-c--red" @click="btnOnStagedRemove(idx)">
										<b-icon-trash />
									</button>
								</td>
							</tr>
						</table>
					</div>
					<div class="txt-c--red mt-2 mb-1">※ 연결주소 목록</div>
					<div class="table-wrap" style="max-height: 20vh">
						<table class="table sm">
							<tr class="sticky">
								<th>도로명주소</th>
								<th>지번주소</th>
								<th>삭제</th>
							</tr>
							<tr v-for="addr in addrList" :key="'linkadr_' + addr.id">
								<td>{{ addr.road_addr }}</td>
								<td>{{ addr.jibun_addr }}</td>
								<td>
									<button type="button" class="btn btn-xsm txt-c--red" @click="btnOnDelete(addr.id, addr.land_index)">
										<b-icon-trash />
									</button>
								</td>
							</tr>
						</table>
					</div>
					<div class="btn-wrap">
						<button type="button" class="btn btn-sm btn-outline-secondary mr-1" @click="isPopupShow6 = false">닫기</button>
						<button type="button" class="btn btn-sm btn-primary" :disabled="!stagedAddresses.length" @click="btnOnBatchSave">확인 ({{ stagedAddresses.length }}건 등록)</button>
					</div>
				</div>
			</div>
		</div>
		<div v-if="isPopupShow7" class="popup-wrap">
			<div class="dim" @click="isPopupShow7 = false"></div>
			<div class="popup lg">
				<div class="popup-tit">
					물건사진 업로드
					<button type="button" class="btn btn-close" @click="isPopupShow7 = false"><b-icon-x-lg /></button>
				</div>
				<div class="popup-con">
					<!-- I1: 사진 슬롯 — v-for 단일 그리드. 슬롯 번호 배지 + 빈/채움 상태 시각화 + 라벨 인풋. -->
					<ul class="photo-grid">
						<li
							v-for="(slot, i) in imgList"
							:key="'photo-slot-' + i"
							class="photo-list--item"
							:class="{ 'is-empty': !slot.veiwSrc, 'is-filled': !!slot.veiwSrc }"
						>
							<span class="slot-num">{{ i + 1 }}</span>
							<label class="file">
								<input type="file" accept="image/*" @change="imgFile($event, i)" />
								<div class="img">
									<img v-if="slot.veiwSrc" :src="slot.veiwSrc" alt="" />
									<div v-else class="placeholder">
										<b-icon-plus-circle />
										<span>사진 추가</span>
									</div>
								</div>
							</label>
							<button v-if="slot.veiwSrc" type="button" class="btn btn-delete" @click="imgDel(i)" aria-label="삭제">&times;</button>
							<input
								type="text"
								class="label-input"
								:value="slot.label ?? defaultImgLabel(i)"
								:placeholder="defaultImgLabel(i)"
								:disabled="!slot.veiwSrc"
								maxlength="40"
								@input="onImgLabelInput(i, $event.target.value)"
							/>
						</li>
					</ul>
					<div class="btn-wrap">
						<button type="button" class="btn btn-sm btn-primary" @click="onImgSave">저장</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
	name: 'MapSearch',
	components: { draggable },
	data() {
		return {
			bid: null,
			item: null,
			memList: [],
			landList: [],
			rentList: [],
			floorList: [],
			floorTotal: { m2: 0, py: 0 },
			floorGroup: [],
			bdCateIdList: [],
			sell_status: null,

			// G-1/G-3: 건폐율/용적률 팝업 — 다중 선택 상태
			blRatioTargetIds: [],
			faRatioExcludeIds: [],

			isLoading: false,

			building_done_log_flag: false,
			building_hold_log_flag: false,

			sum_deposit_py: 0,
			sum_deposit_m2: 0,
			chk_cnt: 0,

			menu1: 0,
			menu2: 0,
			menu3: 0,

			dragging: false,

			typeList: {
				structure: [],
				gmok: [],
				heat_type: [],
				park_type: [],
				use_area: [],
				bd_cate: [],
			},

			isPopupShow1: false,
			isPopupShow2: false,
			isPopupShow3: false,
			isPopupShow4: false,
			isPopupShow5: false,
			isPopupShow6: false,
			isPopupShow7: false,

			mgrLogList: [],
			clientLogList: [],
			workHistoryList: [],
			clientTypeList: [],
			viewObj: {},

			searchOptions: {
				type: '',
				keyword: '',
			},

			totalData: {
				py: 0,
				deposit: 0,
				money: 0,
				mgr: 0,
			},

			memType: false,

			file_1: null,
			fileObj: null, fileUploading: false,
			fileName: '',
			// I1: 사진 슬롯 — file/src/fileSrc/veiwSrc/id 는 기존 필드.
			// label = 사용자 라벨 (NULL = IMG_NAME[i] fallback). initialLabel = 로드 시 백업.
			imgList: Array.from({ length: 20 }, () => ({
				file: null, src: null, fileSrc: null, veiwSrc: null, id: null,
				label: null,
				initialLabel: null,
			})),
			fileList: [],

			map: null,
			marker: null,
			mapType: null,
			adr: '',
			roadAddress: '',
			jibunAddress: '',
			zonecode: null,

			addrList: [],
			linkAddr: null,
			stagedAddresses: [],

			searchInfo: {
				st: false,
				st_: [],
				keyword: '',
			},
			buildingPage: {
				page: 1,
				pageData: null,
				totalCount: null,
				itemSize: 5,
				blockSize: 5,
			},
			buildingList: [],
			linkList: [],
			linkSumObj: {
				sum_monthly_rent: 0,
				sum_deposit: 0,
				sum_main_fee: 0,
				sum_monthly_fixed: 0,
				sum_rent_area_m2: 0,
				sum_rent_area_py: 0,
				sum_rent_py_price: 0,
				sum_net_area_m2: 0,
				sum_net_area_py: 0,
				sum_ex_rate: 0,
				sum_land_price: 0,
				sum_land_size_py_price: 0,
				sum_building_price: 0,
				sum_building_price_py_price: 0,
				sum_total_size_py_price: 0,
				sum_land_size_m2: 0,
				sum_land_size_p: 0,
				sum_public_land_price: 0,
				sum_public_land_price_py_price: 0,
				sum_total_size_m2: 0,
				sum_total_size_p: 0,
				sum_build_size_m2: 0,
				sum_build_size_: 0,

				itemList: [],
				item: {},
			},

			isDirty: false,
			// 화면이 마지막으로 서버에서 받은 토지 칸(syncLandFields). 담당자가 손댄 칸인지 가르는 기준이다.
			landLoaded: {},
			// 화면이 불러온 건축물대장 칸(건폐율·용적률·면적·층수 등). 손대지 않은 칸은 저장 때 서버가 DB 값을 쓴다(DD).
			titleLoaded: {},
			// 불러온 뒤 담당자가 한 번이라도 고친 토지 칸(syncLandFields 가 덮지 않는다)과, 연결주소를 바꾼 뒤 토지 칸을 다시
			// 받지 못한 상태(저장 전에 다시 받는다).
			landTouched: {},
			landStale: false,
			isLoadComplete: false,
			// Bug AI-2: chgSellStatus 의 await btnSaveItem 구간 동안 라디오 4개를
			// disabled 처리해 사용자 더블/연속 클릭으로 인한 핸들러 interleave 차단.
			chgSellStatusPending: false,
			// Bug AG: backMenu("저장하시겠습니까?" → No) 경로가 beforeRouteLeave 의
			// 동일 confirm 을 두번 띄우지 않도록 일회성 bypass. consume-reset.
			allowDirtyLeave: false,
			// Bug AG: leave-save 진행 중 사용자가 추가 nav 를 트리거하면 중복 save +
			// 다이얼로그 race 발생. guard 진입 시 이 플래그가 true 면 즉시 차단.
			isSavingForLeave: false,
		};
	},
	updated() {},
	created() {
		this.init();
	},
	// Bug AH: F5/탭 닫기/주소창 입력 등 브라우저 native 레벨 nav 에서 미저장 입력 휘발 방지.
	// beforeRouteLeave (Bug AG) 는 Vue Router 내부 nav 만 잡고, 브라우저 native unload 는
	// window.beforeunload 가 잡는다. 두 가드는 상호 보완 — Vue Router push 는 beforeRouteLeave,
	// F5/close 는 beforeunload.
	// Chrome 86+ 보안상 커스텀 메시지는 무시되지만 native 다이얼로그는 표시됨 — 실수로
	// 페이지를 떠나 데이터를 잃는 것을 막는 기본 보호장치.
	mounted() {
		this.handleBeforeUnload = (e) => {
			if (this.isDirty && !this.allowDirtyLeave) {
				e.preventDefault();
				e.returnValue = '';
				return '';
			}
		};
		window.addEventListener('beforeunload', this.handleBeforeUnload);
	},
	beforeUnmount() {
		if (this.handleBeforeUnload) {
			window.removeEventListener('beforeunload', this.handleBeforeUnload);
			this.handleBeforeUnload = null;
		}
	},
	// Bug AG: 박시영 신고 root cause 차단. backMenu("View Mode") 외 Vue Router 가 처리하는
	// 모든 in-app navigation (상단 nav, $router.push, 사이드 메뉴) 에서 미저장 입력 침묵
	// 휘발을 차단한다. backMenu 의 save flow 를 재사용.
	//   브라우저 native nav (F5/tab close): Bug AH (mounted/beforeUnmount + beforeunload).
	// UX: nav 컨텍스트에서는 backMenu 와 달리 "취소 = 페이지에 머무름" 이 표준 (브라우저
	// beforeunload 동작과 동일). 입력 보호가 우선이고, 명시적 폐기는 backMenu("View Mode")
	// → "저장하시겠습니까? → 취소" 경로로 분리.
	async beforeRouteLeave() {
		// consume-reset: 외부 가드가 nav 를 취소시켜 컴포넌트가 잔존해도 다음 nav 는
		// 다시 prompt 가 뜨도록 — isDirty 분기보다 먼저 검사해 invariant 보장.
		if (this.allowDirtyLeave) {
			this.allowDirtyLeave = false;
			return true;
		}
		if (!this.isDirty) return true;
		// 진행 중인 leave-save 가 있으면 중복 save 차단.
		if (this.isSavingForLeave) return false;
		if (!confirm('수정 중인 변경사항이 있습니다.\n저장하시겠습니까?\n\n[확인] 저장 후 이동\n[취소] 페이지에 머무름')) return false;
		this.isSavingForLeave = true;
		try {
			if (this.stagedAddresses && this.stagedAddresses.length) {
				const re = await this.btnOnBatchSave({ silent: true });
				if (!re || re.ok !== true) {
					alert((re && re.msg) || '연결주소 저장에 실패했습니다.');
					return false;
				}
			}
			if (this.hasPendingImgChanges && this.hasPendingImgChanges()) {
				const re = await this.onImgSave({ silent: true });
				if (!re || re.ok !== true) {
					alert((re && re.msg) || '이미지 저장에 실패했습니다.');
					return false;
				}
			}
			const re = await this.btnSaveItem();
			if (!re || re.ok !== true) return false;
			return true;
		} finally {
			this.isSavingForLeave = false;
		}
	},
	computed: {
		filteredMgrLogList() {
			return this.mgrLogList.filter(log => {
				if (log.sub_type_key === 'sell_status' && log.memo && log.memo.startsWith('작업중:')) return false;
				return true;
			});
		},
		combinedWorkList() {
			const rows = [];
			for (const wh of this.workHistoryList) {
				rows.push({
					kind: 'work',
					key: 'wh_' + wh.ts,
					date: wh.ts,
					label: '작업시작',
					doer: wh.assignee_name || '',
					desc: `작업기한: ${wh.sdate} ~ ${wh.edate}`,
				});
			}
			// 담당자 변경(building_mem_uid)은 변경내역 탭(filteredMgrLogList)에서만 렌더.
			// 여기선 sell_status 의 '작업중:' 구버전 작업시작 엔트리만 병합.
			for (const log of this.mgrLogList) {
				if (log.sub_type_key === 'sell_status' && log.memo && log.memo.startsWith('작업중:')) {
					rows.push({
						kind: 'work',
						key: 'ml_' + log.mgr_log_uid,
						date: log.date,
						label: '작업시작',
						doer: log.mem_name || '',
						desc: log.memo,
					});
				}
			}
			for (const log of this.clientLogList) {
				rows.push({
					kind: 'client',
					key: 'cl_' + log.client_log_uid,
					date: log.date,
					log,
				});
			}
			// `wh.ts` 는 'YYYY-MM-DD HH:mm:ss' (SP_R_BUILDING_WORK_START DATE_FORMAT),
			// `log.date` 는 ISO 'YYYY-MM-DDTHH:mm:ss.000Z'. 문자열 비교 시 space(0x20)
			// < 'T'(0x54) 라 작업시작·담당자 변경이 고객상담보다 위로 몰리므로 epoch 기준으로 정렬.
			const toEpoch = d => (d ? new Date(String(d).replace(' ', 'T')).getTime() : 0);
			rows.sort((a, b) => toEpoch(b.date) - toEpoch(a.date));
			return rows;
		},
		// G-1/G-3: 건폐율 대상 선택 항목 면적 합계 (㎡)
		blRatioTargetArea() {
			if (!Array.isArray(this.floorList) || !this.floorList.length) return 0;
			return this.floorList
				.filter(f => this.blRatioTargetIds.includes(f.building_floor_uid))
				.reduce((s, f) => s + Number(f.area_m2 || 0), 0);
		},
		// G-1: 용적률 대상면적 = 연면적 - (용적률 제외 선택 항목 면적 합계)
		faRatioTargetArea() {
			const total = Number((this.item && this.item.total_size_m2) || 0);
			if (!Array.isArray(this.floorList) || !this.floorList.length) return total;
			const exc = this.floorList
				.filter(f => this.faRatioExcludeIds.includes(f.building_floor_uid))
				.reduce((s, f) => s + Number(f.area_m2 || 0), 0);
			return total - exc;
		},
		// G-1: 건폐율 = 건폐율 대상면적 / 대지면적 * 100 (단위 %)
		calcBlRatio() {
			const land = Number((this.item && this.item.land_size_m2) || 0);
			if (!land) return '0.00';
			return ((this.blRatioTargetArea / land) * 100).toFixed(2);
		},
		// G-1: 용적률 = 용적률 대상면적 / 대지면적 * 100 (단위 %)
		calcFaRatio() {
			const land = Number((this.item && this.item.land_size_m2) || 0);
			if (!land) return '0.00';
			return ((this.faRatioTargetArea / land) * 100).toFixed(2);
		},
		// G-2: 작업중 (신규~14일) — working_edate 가 오늘(로컬 KST 기준) 이상이면 작업중.
		// 빈/기본값('0000-00-00') 은 '배정된 적 없음' 으로 간주해 false.
		// new Date('YYYY-MM-DD') 는 UTC 자정으로 파싱되어 KST 09:00 이후 기한 당일이
		// false 로 바뀌는 버그가 있어, 로컬 YYYY-MM-DD 문자열 비교로 day-inclusive 판정한다.
		isWorkingActive() {
			// F-6.2 fix: working_edate may arrive as ISO UTC or 'YYYY-MM-DD'.
			// See MapDetail.vue:isWorkingActive for the timezone rationale.
			if (!this.item) return false;
			const ed = this.item.working_edate;
			if (!ed || ed === '0000-00-00') return false;
			const edDate = new Date(ed);
			if (isNaN(edDate.getTime())) return false;
			const edStr = `${edDate.getFullYear()}-${String(edDate.getMonth() + 1).padStart(2, '0')}-${String(edDate.getDate()).padStart(2, '0')}`;
			const now = new Date();
			const todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
			return todayStr <= edStr;
		},
		// G-2: 매물/매각 상태에서는 작업 UI 전체 숨김 (도형+버튼 모두).
		hideWorkUi() {
			if (!this.item) return true;
			return this.item.sell_status === 'done' || this.item.sell_status === 'sell';
		},
	},
	watch: {
		// F-3.2: dirty tracking — view-mode 전환 시 "저장하시겠습니까?" 팝업 트리거.
		//   item             : 물건정보 input 전반 (v-model="item.*")
		//   rentList         : 임대차내역 행
		//   floorList        : 건축물대장 각 층 `chk_except` 토글
		//   imgList          : 사진 추가/삭제 (imgFile / imgDel) — btnSaveItem 은 이미지 업로드를
		//                      save flow 에 포함하지 않으므로 "예" 선택 시 저장되지 않을 수 있으나,
		//                      사용자 "수정 없이 나가려 했는가" 의도 판정에는 포함되어야 한다.
		//   stagedAddresses  : 연결주소 일괄등록 대기 목록 (btnOnStagedAdd) — 사용자가
		//                      일괄등록(btnOnBatchSave) 을 누르지 않고 나가려 할 때 환기 필요.
		item: {
			handler() {
				if (this.isLoadComplete) this.isDirty = true;
			},
			deep: true,
		},
		rentList: {
			handler() {
				if (this.isLoadComplete) this.isDirty = true;
			},
			deep: true,
		},
		floorList: {
			handler() {
				if (this.isLoadComplete) this.isDirty = true;
			},
			deep: true,
		},
		imgList: {
			handler() {
				if (this.isLoadComplete) this.isDirty = true;
			},
			deep: true,
		},
		stagedAddresses: {
			handler() {
				if (this.isLoadComplete) this.isDirty = true;
			},
			deep: true,
		},
		// G-1: 팝업이 닫힐 때마다 체크 상태를 초기화해 다음 열람 시 깨끗한 상태로 시작.
		// 적용(applyBlFaRatio) 단계에서 이미 item.bl_ratio/fa_ratio 에 계산값을 반영했으므로
		// 닫힌 뒤 선택 상태를 유지할 필요가 없다.
		isPopupShow4(shown) {
			if (!shown) {
				this.blRatioTargetIds = [];
				this.faRatioExcludeIds = [];
			}
		},
	},
	methods: {
		// G-1: 팝업 계산 결과를 매물 필드로 반영 (이후 사용자 직접 수정 허용)
		// DD (2026-10-15): 건폐율·용적률은 건축물대장 값이 원칙이다. 이 계산기는 대장에 값이 없을 때 참고용이라, 고른 층이
		// 있는 칸만 바꾸고 바꾸기 전에 확인을 받는다. 예전에는 아무것도 고르지 않고 '적용' 을 누르면 대장 값(청담동
		// 46-17: 59.27%·399.98%)이 0%·535.89%(지하층까지 든 연면적 ÷ 대지면적)로 바뀌었다(codex B-03).
		applyBlFaRatio() {
			if (!this.item) return;
			const bl = this.blRatioTargetIds.length ? this.calcBlRatio : null;
			const fa = this.faRatioExcludeIds.length ? this.calcFaRatio : null;
			if (bl == null && fa == null) {
				alert('건폐율 대상 층이나 용적률 제외 층을 하나 이상 고르세요.\n\n고르지 않은 칸은 바꾸지 않습니다.');
				return;
			}
			const lines = [];
			if (bl != null) lines.push(`건폐율 ${this.item.bl_ratio || 0}% → ${bl}%`);
			if (fa != null) lines.push(`용적률 ${this.item.fa_ratio || 0}% → ${fa}%`);
			if (!confirm('건축물대장에 건폐율·용적률이 있으면 대장 값을 쓰는 것이 원칙입니다.\n고른 층으로 계산한 값으로 바꿀까요?\n\n' + lines.join('\n'))) return;
			if (bl != null) this.item.bl_ratio = bl;
			if (fa != null) this.item.fa_ratio = fa;
			this.isPopupShow4 = false;
		},
		// G-1: 팝업을 닫는다. 제외(chk_except) 체크는 즉시 floorList 상태를 변경하며—이는 앱 전반의 기존 제외 체크박스
		// 동작과 일치한다. 따라서 버튼 라벨도 취소가 아닌 "닫기".
		cancelBlFaRatio() {
			this.isPopupShow4 = false;
		},
		// G-2: "작업하기" — 14일 작업 우선권 부여 (임대). isRent=true 로 POST,
		// backend 가 SP_R_BUILDING_WORK_START 경로로 분기한다.
		async btnStartWork() {
			if (this.hideWorkUi) return;
			if (this.isWorkingActive) return;

			const deadline = new Date();
			deadline.setDate(deadline.getDate() + 13);
			const y = deadline.getFullYear();
			const m = String(deadline.getMonth() + 1).padStart(2, '0');
			const d = String(deadline.getDate()).padStart(2, '0');
			const msg = `${y}년 ${m}월 ${d}일까지 작업 우선권이 부여됩니다.\n작업하시겠습니까?`;
			if (!confirm(msg)) return;

			const result = await this.$apiPOST('/admin/api/building/work/start', {
				bid: this.bid,
				isRent: true,
			});
			if (result && result.success) {
				alert('작업이 시작되었습니다.');
				// Bug AA: location.reload() 제거 — Bug Y 동일 사유의 회귀.
				// 박시영 보고: 매물 입력 도중 작업하기 누르면 임대차/특징/입금가/매매금액/주변역
				// 등 미저장 텍스트 입력이 init() → getItem() 으로 휘발 (사진은 별도 경로라 살아남음).
				// 작업 상태는 응답 sdate/edate/assignee_uid 를 in-place patch + 작업내역 탭만 재페치.
				// Codex round-1: API 응답의 assignee_uid 는 schema 컬럼 working_mem_uid 에 매핑되므로
				// item.working_mem_uid 로 patch (기존 schema 의 실제 필드명).
				if (this.item) {
					this.item.working_sdate = result.sdate;
					this.item.working_edate = result.edate;
					this.item.working_mem_uid = result.assignee_uid;
				}
				this.getWorkHistory();
			} else {
				alert((result && result.message) || '작업 시작 실패');
			}
		},
		init() {
			window.resultAddress2 = this.resultAddress2;

			this.bid = this.$route.params.id;

			// Bug AY: 매매측 MapWrite.init 와 대칭 — `/LeaseMapWrite/undefined` 등 직접
			// 진입 (외부 북마크, 수동 URL 등) 시 8개 GET fan-out 이 bid='undefined' 로
			// 발사되는 것을 차단. backend bid-guard 가 alert 를 8번 띄우는 UX 폭격 방지.
			const bidStr = String(this.bid);
			if (!this.bid || bidStr === 'undefined' || bidStr === 'null') {
				alert('잘못된 접근입니다. 매물 목록에서 다시 선택해주세요.');
				this.$router.replace('/');
				return;
			}

			this.getItem();
			this.getMgrLog();
			this.getClientLog();
			this.getWorkHistory();
			this.getClientType();
			this.getLand();
			this.getMem();
			this.getView();
			this.getFileList();

			this.getAddrList();

			for (let prop in this.typeList) {
				this.getType(prop);
			}
		},
		getItem() {
			this.$apiGET('/admin/api/detail/item?bid=' + this.bid + '&isRent=true').then(data => {
				// Bug AF: 백엔드 routes/index.js:745 가 row 미존재 시 res.send(false) 반환 →
				// data === false 가 흘러와 data.bd_cate_uid.split() 에서 TypeError 발생.
				// 발생 빈도는 낮지만 (잘못된 URL / 삭제된 매물) 발생 시 페이지 전체 깨짐.
				// silent abort 대신 사용자에게 알리고 목록으로 복귀.
				if (!data || typeof data !== 'object') {
					alert('해당 매물 정보를 찾을 수 없습니다.\n매물 목록으로 돌아갑니다.');
					this.allowDirtyLeave = true;
					this.$router.go(-1);
					return;
				}
				for (let prop in data) {
					if (data[prop] == null) {
						data[prop] = '';
					}
				}
				data.build_date = this.$dateFormat(data.build_date);
				data.remodel_date = this.$dateFormat(data.remodel_date);
				data.bd_cate_uid = data.bd_cate_uid.split(',');

				// F-2.1: 레거시 row 에 "서울특별시 … 번지" 형태 주소가 legacy 로 남아 있을 수 있으므로
				// ingestion 지점에서 한 번 정규화해 템플릿/linkSumObj/linkAddr 경로가 동일한
				// 표기를 쓰도록 한다. 저장 payload 는 raw 주소를 다시 만들지 않으므로 안전.
				data.jibun_addr = this.$normalizeAddr(data.jibun_addr);
				data.road_addr = this.$normalizeAddr(data.road_addr);

				this.item = data;
				this.landLoaded = this.pickLandFields(data);
				this.titleLoaded = this.pickTitleFields(data);
				this.landTouched = {};
				this.landStale = false;

				// I1: 라벨 응답 추가 — SP 미반환 가능성에 대비해 옵셔널.
				const respLabels = Array.isArray(this.item.imgLabels) ? this.item.imgLabels : [];
				for (let i = 0; i < this.imgList.length; i++) {
					if (this.item.imgList[i]) {
						this.imgList[i].src = this.item.imgList[i];
						this.imgList[i].veiwSrc = process.env.VUE_APP_HOST_BACK + '/users/item/image2?id=' + this.item.imgList[i] + '&w=1200&q=82';
					}
					this.imgList[i].label = respLabels[i] ?? null;
					this.imgList[i].initialLabel = this.imgList[i].label;
				}

				this.sell_status = this.item.sell_status;

				if (
					this.item.building_mem_uid == this.$store.getters.getUserInfo.mem_uid ||
					'master' == this.$store.getters.getUserInfo.mem_type
				) {
					this.memType = true;
				}

				this.linkSumObj.item = {
					building_name: data.building_name,
					jibun_addr: data.jibun_addr,

					monthly_rent: data.monthly_rent,
					deposit: data.deposit,
					main_fee: data.main_fee,
					monthly_fixed: data.monthly_fixed,
					rent_area_m2: data.rent_area_m2,
					rent_area_py: data.rent_area_py,
					rent_py_price: data.rent_py_price,
					net_area_m2: data.net_area_m2,
					net_area_py: data.net_area_py,
					ex_rate: data.ex_rate,
					land_price: data.land_price,
					land_size_py_price: data.land_size_py_price,
					building_price: data.building_price,
					building_price_py_price: data.building_price_py_price,
					total_size_py_price: data.total_size_py_price,
					land_size_m2: data.land_size_m2,
					land_size_p: data.land_size_p,
					public_land_price: data.public_land_price,
					public_land_price_py_price: data.public_land_price_py_price,
					total_size_m2: data.total_size_m2,
					total_size_p: data.total_size_p,
					build_size_m2: data.build_size_m2,
					build_size_p: data.build_size_p,
				};

				this.getList();
				this.getRent();
			});
		},
		getMem() {
			this.$apiGET('/admin/api/setting/etc/mem').then(data => {
				this.memList = data;
			});
		},
		// DD: 건축물대장 칸. 다른 화면의 새로고침·연결주소 삭제나 일괄 보정이 고친 대장 값을, 이 화면이 옛 값을 쥔 채 저장해
		// 되돌리지 않게 불러온 값을 함께 보낸다(서버 _mergeTitleOnSave).
		pickTitleFields(src) {
			const out = {};
			for (const k of ['bl_ratio', 'fa_ratio', 'build_size_m2', 'build_size_p', 'total_size_m2', 'total_size_p', 'floor_cnt_F', 'floor_cnt_B', 'structure_uid', 'ev_cnt', 'park_cnt_law', 'main_purpose', 'build_date']) {
				out[k] = src ? src[k] : null;
			}
			return out;
		},
		// 대장 칸 비교. 숫자 칸은 서버(_mergeTitleOnSave)와 같이 빈 칸과 0 을 가르고 표기('50.00' 과 50)는 같게 본다.
		sameTitleValue(k, a, b) {
			if (k === 'main_purpose' || k === 'build_date') return String(a == null ? '' : a).trim() === String(b == null ? '' : b).trim();
			const n = (v) => (v == null || String(v).trim() === '' ? null : Number(v));
			return n(a) === n(b);
		},
		pickLandFields(src) {
			const out = {};
			for (const k of ['land_size_m2', 'land_size_p', 'public_land_price', 'public_land_price_py_price', 'gmok', 'use_area_uid']) {
				out[k] = src ? src[k] : null;
			}
			return out;
		},
		// 연결주소를 추가·삭제하면 서버가 대지면적·공시지가 합계·지목·용도지역을 다시 계산한다. 이 칸들은 저장할 때
		// 화면 값이 그대로 다시 쓰여서, 옛 값을 쥔 채 저장하면 새 합계가 옛 값(대개 대표 필지 하나 값)으로 돌아갔다
		// (운영 147건). 담당자가 손대지 않은 칸만 새 값으로 바꾸고(손댄 칸은 담당자 입력이 이긴다), 다른 미저장 입력과
		// 변경 표시는 그대로 둔다. 숫자 칸은 비어 있음·0 을 같은 값으로 본다(입력 컴포넌트가 빈 값을 0 으로 바꾼다).
		// 한 번 고친 칸은 다시 덮지 않는다(landTouched). 고친 값이 마침 그때 서버 값과 같으면 손대지 않은 칸처럼 보여 다음
		// 동기화가 덮었다(codex 리뷰). 받지 못하면 false 를 돌려주고 저장 전에 다시 받는다(landStale).
		async syncLandFields() {
			const data = await this.$apiGET('/admin/api/detail/item/land/summary?bid=' + this.bid + '&isRent=true');
			if (!this.item) return false;
			if (!data || typeof data !== 'object') {
				this.landStale = true;
				return false;
			}
			const wasDirty = this.isDirty;
			const same = (a, b) => Number(a || 0) === Number(b || 0);
			const fresh = this.pickLandFields(data);
			for (const k of Object.keys(fresh)) {
				if (this.landTouched[k] || !same(this.item[k], this.landLoaded[k])) this.landTouched[k] = true;
				else this.item[k] = fresh[k];
			}
			// 토지평단가는 대지평으로 나눈 값이라 대지평을 바꿨으면 다시 계산한다(onUpdateData 와 같은 식).
			if (!this.landTouched.land_size_p && Number(this.item.land_size_p) > 0 && this.item.land_price != null && this.item.land_price !== '') {
				this.item.land_size_py_price = Math.round(Number(this.item.land_price) / Number(this.item.land_size_p));
			}
			this.landLoaded = fresh;
			this.landStale = false;
			await this.$nextTick();
			this.isDirty = wasDirty;
			return true;
		},
		getLand() {
			// Codex round-1: caller (btnOnBatchSave/btnOnDelete) 가 await 가능하도록 promise 반환.
			return this.$apiGET('/admin/api/detail/item/edit/land2?bid=' + this.bid).then(data => {
				this.landList = data;
			});
		},
		getType(part) {
			this.$apiGET('/admin/api/setting?part=' + part).then(data => {
				this.strucList = data;

				this.typeList[part] = data;

				// G-2: 종류 SlimSelect 가 헤더에서 제거되면서 v-model 로 bdCateIdList 를
				// 채우던 경로가 사라졌다. 저장 시 `cate` 페이로드가 빈 배열이면 서버가
				// 기존 카테고리를 전부 지우게 되므로, 서버에서 받은 현재 cate 를
				// bdCateIdList 에 직접 반영해 데이터 손실을 방지한다.
				if (part == 'bd_cate') {
					this.$apiGET('/admin/api/cate2/get?bid=' + this.bid).then(data => {
						this.bdCateIdList = (Array.isArray(data) ? data : []).map(String);
					});
				}
			});
		},
		getRent() {
			this.$apiGET('/admin/api/detail/item/rent2?bid=' + this.bid).then(data => {
				if (data.length) {
					this.rentList = data;
				} else {
					this.addFloorTable();
				}

				this.getFloor();
			});
		},
		getFloor() {
			this.$apiGET('/admin/api/detail/item/floor2?bid=' + this.bid).then(data => {
				this.floorList = data;

				this.onUpdateData();
				this.onUpdateFloor();

				this.$nextTick(() => {
					this.isDirty = false;
					this.isLoadComplete = true;
				});
			});
		},
		getClientLog() {
			this.$apiGET('/admin/api/detail/item/clientlog2?bid=' + this.bid).then(data => {
				this.clientLogList = data;
			});
		},
		getWorkHistory() {
			this.$apiGET('/admin/api/detail/item/workhistory?bid=' + this.bid + '&isRent=true').then(data => {
				this.workHistoryList = data;
			});
		},
		addClientLog() {
			// J-2/Bug V: backend tx 5xx 시 keyword reset / getClientLog 차단.
			this.$apiPOST('/admin/api/client/log/add2', {
				bid: this.bid,
				type: this.searchOptions.type,
				keyword: this.searchOptions.keyword,
				memUid: this.item.building_mem_uid,
			}).then(re => {
				if (re !== true) return;
				this.searchOptions.keyword = '';
				this.getClientLog();
			});
		},
		getMgrLog() {
			this.$apiGET('/admin/api/detail/item/mgrlog2?bid=' + this.bid).then(data => {
				this.mgrLogList = data;
			});
		},
		async getClientType() {
			const list = await this.$store.dispatch('ensureClientTypeList', () =>
				this.$apiGET('/admin/api/detail/item/clienttype'),
			);
			this.clientTypeList = list;

			if (this.clientTypeList.length) {
				this.searchOptions.type = this.clientTypeList[0].ind_cfg_uid;
			}
		},
		getView() {
			this.$apiGET('/admin/api/detail/item/view2?bid=' + this.bid).then(data => {
				this.viewObj = data;
			});
		},
		onEnd() {
			for (let i = 0; i < this.rentList.length; i++) {
				this.rentList[i].rent_index = i + 1;
			}
		},
		onUpdateFloor() {
			let m2 = 0;
			let py = 0;

			for (let i = 0; i < this.floorList.length; i++) {
				// 면적은 제외 대상과 무관하게 항상 합산 (F-3.4)
				// 건축물대장이 면적 제외로 표시한 행(옥탑 계단실 등)은 연면적에 들지 않는다(DD). 담당자 제외 체크와는 별개다.
				if (String(this.floorList[i].areaExctYn) === '1') continue;
				m2 += Number(this.floorList[i].area_m2) || 0;
				py += Number(this.floorList[i].area_py) || 0;
			}

			this.floorTotal.m2 = m2.toFixed(2);
			this.floorTotal.py = py.toFixed(2);
		},
		onUpdateData() {
			let py = 0;
			let deposit = 0;
			let money = 0;
			let mgr = 0;

			for (let i = 0; i < this.rentList.length; i++) {
				// 면적은 제외 대상과 무관하게 항상 합산 (F-3.4)
				py += Number(this.rentList[i].rent_size_p);
				if (this.rentList[i].except_flag != 'Y') {
					deposit += Number(this.rentList[i].rent_deposit);
					money += Number(this.rentList[i].rent_money);
					mgr += Number(this.rentList[i].mgr_fee);

					if (this.rentList[i].rent_size_p > 0 && this.rentList[i].rent_money > 0) {
						this.rentList[i].rent_ni = (this.rentList[i].rent_money / this.rentList[i].rent_size_p).toFixed(2);
					} else {
						this.rentList[i].rent_ni = 0;
					}
				}
			}

			this.item.ex_sum_rent_deposit = deposit;
			this.item.ex_sum_rent_money = money;
			this.item.ex_sum_mgr_fee = mgr;

			this.totalData.py = py.toFixed(2);
			this.totalData.deposit = deposit;
			this.totalData.money = money;
			this.totalData.mgr = mgr;

			// let totEarn = mgr + money;

			let mgrEarn = this.item.ex_sum_mgr_fee - this.item.ex_sum_mgr_fee_out;
			let totEarn = this.item.ex_sum_rent_money + mgrEarn;

			let rateEarn = 0;
			let monthRateEarn = 0;

			// 분모(매매가 − 보증금 합계)가 0 이면 나누지 않는다(2026-10-03). 매매가를 넣기 전에 월세만 있으면
			// Infinity 가 되고, 아래 toFixed 가 그것을 문자열 'Infinity' 로 만들어 저장이 서버에서 통째로 거절됐다
			// (운영 2026-09: 14건, 한 매물은 8번 연속). 그때 수익률은 '수익 없음' 과 같은 0 으로 둔다.
			const rateBase = Number(this.item.sell_price) - Number(this.item.ex_sum_rent_deposit);
			const hasRateBase = Number.isFinite(rateBase) && rateBase !== 0;

			if (totEarn > 0 && hasRateBase) {
				rateEarn = ((totEarn * 12) / rateBase) * 100;
				monthRateEarn = (totEarn / rateBase) * 100;
			}

			//////// 연면적평단가
			this.item.total_income =
				this.item.ex_sum_rent_money * 1 + this.item.ex_sum_mgr_fee * 1 - this.item.ex_sum_mgr_fee_out * 1;

			this.item.total_income_rate = hasRateBase
				? Number((((this.item.total_income * 12) / rateBase) * 100).toFixed(2))
				: 0;

			this.item.earning_rate = (Math.round(rateEarn * 100) / 100).toFixed(2);
			this.item.earning_month_rate = Math.round(monthRateEarn * 1000) / 1000;

			let total_size_p = this.item.total_size_m2 * this.$M2_PY_EX;
			let total_size_py_price = 0;

			if (this.item.sell_price > 0 && total_size_p > 0) {
				total_size_py_price = Math.round(this.item.sell_price / total_size_p);
			}

			this.item.total_size_py_price = total_size_py_price;

			/////// 토지평단가

			this.item.building_price = Math.round(this.item.building_price_py_price * total_size_p);

			let land_price = 0;

			if (this.item.sell_price > 0) {
				land_price = this.item.sell_price - this.item.building_price;
			}

			this.item.land_price = land_price;

			if (this.item.land_size_p > 0) {
				this.item.land_size_py_price = Math.round(this.item.land_price / this.item.land_size_p);
			}

			this.calcFloor();
		},
		onUpdateData2() {
			// this.item.monthly_fixed = Number(this.item.monthly_rent) + Number(this.item.main_fee);

			const rent_area_py = Number((this.item.rent_area_m2 * 0.3025).toFixed(2));
			this.item.rent_py_price = Number((this.item.monthly_rent / rent_area_py).toFixed(2));

			this.item.ex_rate = Number((this.item.net_area_m2 / this.item.rent_area_m2).toFixed(2)) * 100;
		},
		addFloorTable() {
			this.rentList.push({
				building_rent_uid: null,
				end_date: '',
				except_flag: 'N',
				memo: '',
				mgr_fee: '0',
				rent_deposit: 0,
				rent_floor: '',
				rent_index: this.rentList.length + 1,
				rent_money: 0,
				rent_ni: 0,
				rent_size_p: 0,
				rent_usage: '',
			});
		},
		calcFloor() {
			let result = [];
			let sum_deposit_py = 0;
			let sum_deposit_m2 = 0;
			let sum_total_m2 = 0;
			let chk_cnt = 0;

			this.floorList.reduce(function (res, value) {
				if (value.chk_except == 'N') {
					if (value.chk_pa == 'N') {
						if (!res[value.flrNoNm]) {
							res[value.flrNoNm] = {
								flrNoNm: value.flrNoNm,
								area_m2: 0,
								area_py: 0,

								pa_rate: 0,
								divide_m2: 0,
								divide_py: 0,
								rent_py: 0,
							};
							result.push(res[value.flrNoNm]);
						}
						res[value.flrNoNm].area_m2 += value.area_m2;
						res[value.flrNoNm].area_py += value.area_py;
						sum_total_m2 += value.area_m2;
					} else {
						sum_deposit_py += value.area_py;
						sum_deposit_m2 += value.area_m2;
						chk_cnt++;
					}
				}

				return res;
			}, {});

			for (let i = 0; i < result.length; i++) {
				const rate = (result[i].area_m2 / sum_total_m2) * 100;
				result[i].pa_rate = Math.round(rate * 1000) / 1000;

				const divide_m2 = (rate / 100) * sum_deposit_m2;
				const divide_py = divide_m2 * this.$M2_PY_EX;

				result[i].area_m2 = Math.round(result[i].area_m2 * 1000) / 1000;
				result[i].area_py = Math.round(result[i].area_py * 1000) / 1000;
				result[i].divide_m2 = Math.round(divide_m2 * 1000) / 1000;
				result[i].divide_py = Math.round(divide_py * 1000) / 1000;
				result[i].rent_py = Math.round((result[i].area_py * 1 + result[i].divide_py * 1) * 1000) / 1000;
			}

			this.floorGroup = result;
			this.sum_deposit_m2 = sum_deposit_m2.toFixed(2);
			this.sum_deposit_py = sum_deposit_py.toFixed(2);
			this.chk_cnt = chk_cnt;
		},
		// F-3.2: dirty 상태에서 View Mode 로 나가려 할 때 확인 팝업을 띄우고 "예"면 저장하고 이동.
		// btnSaveItem 은 item/rent/cate 만 저장하므로, 사진(imgList) 과 연결주소(stagedAddresses)
		// 변경분도 이 경로에서 함께 커밋해야 한다. 각 커밋 헬퍼의 UI 사이드이펙트(alert, router.go)는
		// silent 모드로 억제하고, 마지막 btnSaveItem({exitAfter:true}) 이 "저장 완료" alert 와
		// router.go(-1) 로 흐름을 종결짓는다. 순서: staged → img → item (item 이 최종 네비게이션).
		// 실패 처리: silent 헬퍼가 {ok:false} 를 반환하면 alert 후 네비게이션을 중단해
		// 사용자 입력이 말없이 유실되는 상황을 방지한다.
		async backMenu() {
			if (this.isDirty) {
				if (confirm('저장하시겠습니까?')) {
					if (this.stagedAddresses.length) {
						const re = await this.btnOnBatchSave({ silent: true });
						if (re && re.ok === false) {
							alert(re.msg || '연결주소 저장에 실패했습니다.');
							return;
						}
					}
					if (this.hasPendingImgChanges()) {
						const re = await this.onImgSave({ silent: true });
						if (re && re.ok === false) {
							alert(re.msg || '이미지 저장에 실패했습니다.');
							return;
						}
					}
					await this.btnSaveItem({ exitAfter: true });
					return;
				}
				// Bug AG: 사용자가 "저장 안함" 을 선택했으므로 beforeRouteLeave 의 중복 prompt 를 우회.
				this.allowDirtyLeave = true;
			}
			this.$router.go(-1);
		},
		// F-3.2: imgList 에 사용자 변경(신규 업로드 fileSrc / 삭제 표시 id)이 있는지.
		// getItem 직후 상태는 src/veiwSrc 만 채워지므로 fileSrc·id 둘 다 falsy — 변경 없음으로 판정.
		hasPendingImgChanges() {
			return this.imgList.some(i => i.fileSrc || i.id);
		},
		btnSaveFloor() {
			if (
				!confirm('공용면적안분 결과를 임대차내역에 등록하시겠습니까?\n\n기존에 등록된 공용면적안분 결과는 삭제됩니다.')
			) {
				return;
			}

			this.$apiPOST('/admin/api/detail/item/floor/edit2', {
				floorList: this.floorList,
				floorGroup: this.floorGroup,
				bid: this.bid,
			}).then(re => {
				// J-2: backend success → res.send(true) / fail → 5xx (resolves false) /
				// 401 → 로그인 redirect (resolves undefined). 실패·재인증 후에는 main
				// item 저장이 진행되면 안 된다 (floor 롤백 + main 만 저장 → silent
				// 부분 저장). success 가 명확한 true 일 때만 진행한다.
				if (re !== true) return;
				this.btnSaveItem();
			});
		},
		// F-3.2: backMenu 가 await btnSaveItem 으로 저장-후-네비게이션을 순차화할 수 있도록
		// $apiPOST 체인 promise 를 그대로 반환한다. 기존의 fire-and-forget click 핸들러는
		// 반환값을 소비하지 않으므로 영향 없음.
		btnSaveItem(options = {}) {
			// 연결주소를 바꾼 뒤 토지 칸을 다시 받지 못했으면 지금 받는다. 못 받으면 저장하지 않는다(옛 합계로 되돌리게 된다).
			if (this.landStale) {
				return this.syncLandFields().then(ok => {
					if (ok) return this.btnSaveItem(options);
					alert('연결주소를 바꾼 뒤 대지면적·공시지가를 다시 불러오지 못해 저장하지 않았습니다.\n잠시 후 다시 저장해 주세요.');
					return { ok: false };
				});
			}
			if (
				this.item.roadwide_1 > 32767 ||
				this.item.roadwide_2 > 32767 ||
				this.item.roadwide_3 > 32767 ||
				this.item.roadwide_4 > 32767
			) {
				alert('도로 범위 오버');
				return;
			}

			this.onUpdateData();
			this.onUpdateFloor();

			// 임대차 금액 상한(2026-10-03). 보증금·월세·관리비는 만원 단위이고 DB 칸이 INT(상한 2,147,483,647)다.
			// 원 단위로 적으면 합계가 상한을 넘어 서버가 영문 'Out of range value' 로 저장을 거절했다(운영 2026-09-18).
			const INT_MAX = 2147483647;
			const tooBig = (v) => Number(v) > INT_MAX;
			if (
				this.rentList.some(r => tooBig(r.rent_deposit) || tooBig(r.rent_money) || tooBig(r.mgr_fee)) ||
				tooBig(this.item.ex_sum_rent_deposit) || tooBig(this.item.ex_sum_rent_money) || tooBig(this.item.ex_sum_mgr_fee)
			) {
				alert('임대차내역 금액이 너무 큽니다. 보증금·월세·관리비는 만원 단위로 입력해 주세요.');
				return;
			}

			// 보낸 대장 칸과 화면 값. 응답을 기다리는 사이 담당자가 고친 칸은 서버 값으로 덮지 않고, 저장 뒤에도 '저장 안 한
			// 변경' 으로 남긴다(안 그러면 그 편집을 쥔 채 저장 확인 없이 화면을 떠난다, codex 리뷰).
			const titleSent = this.pickTitleFields(this.item);
			const itemSent = JSON.stringify(this.item);
			return this.$apiPOST('/admin/api/detail/item/save2', {
				item: this.item,
				rent: this.rentList,
				cate: this.bdCateIdList.map(Number),
				// 불러온 토지 칸. 손대지 않은 칸은 서버가 지금 DB 값으로 저장한다(그사이 다른 화면·일괄 보정이 고친 합계를
				// 옛 값으로 되돌리지 않게, 서버 _mergeLandOnSave).
				landBase: this.landLoaded,
				titleBase: this.titleLoaded,
			}).then(async re => {
				// F-3.2: $apiPOST resolves false/undefined on 4xx/5xx — guard
				// before success alert + dirty-clear + navigation so save-prompt
				// 예 path doesn't lose changes silently after API failure.
				if (!re) {
					// $apiPOST 는 실패 사유(예: "'소유자정보 성명' 칸에 입력한 내용이 너무 깁니다")를
					// 이미 alert 으로 보여준다. 그 위에 일반 문구를 덧띄우면 사용자가 마지막에 보는
					// 문장이 원인 설명을 덮어버리므로, 아무 안내도 없었을 때만 띄운다.
					if (!this.$didApiAlert()) alert('저장 실패. 다시 시도해 주세요.');
					return { ok: false };
				}
				// 아래에서 서버 값을 넣기 전에 잰다.
				const editedWhileSaving = JSON.stringify(this.item) !== itemSent;
				// Bug AV: server 가 SP_R_DETAIL_ITEM_RENT_ADD 후 채워준 새 building_rent_uid
				// (+ rent_floor 빈 row splice 결과) 를 local rentList 에 동기화. 안 하면
				// 새 row 가 undefined uid 로 남아 다음 저장 때 또 INSERT 분기를 타고,
				// 같은 row 가 매번 새로 들어가 누적됨. 박시영 보고: "임대차내역 저장하면
				// 중복돼서 계속 저장된다".
				if (Array.isArray(re.rentList)) {
					this.rentList = re.rentList;
				}
				// 서버가 손대지 않은 대장 칸(건폐율 등)을 지금 DB 값으로 저장했으면 화면도 그 값으로 맞추고, 다음 저장의
				// 기준값을 새로 잡는다. 안 그러면 이 화면에서 다시 저장할 때 그사이 다른 곳이 고친 값을 덮는다(DD).
				const taken = re.title && typeof re.title === 'object' ? re.title : {};
				for (const k of Object.keys(taken)) {
					if (this.sameTitleValue(k, this.item[k], titleSent[k])) this.item[k] = taken[k];
				}
				// 다음 저장의 기준은 지금 DB 에 들어간 값이다(보낸 값에 서버가 가져온 칸을 얹은 것).
				this.titleLoaded = { ...titleSent, ...taken };
				// 서버가 연면적을 DB 값으로 가져왔으면 건물가격·토지가격·토지평단가 표시도 그 연면적으로 다시 낸다(서버가 저장한
				// 토지평단가와 같은 식). 안 그러면 아래 syncLandFields 가 옛 토지가격으로 평단가를 표시한다.
				if (['total_size_m2', 'total_size_p'].some((k) => k in taken)) this.onUpdateData();
				// 서버가 손대지 않은 토지 칸을 DB 값으로 저장했을 수 있다. 화면도 그 값으로 맞춘다.
				await this.syncLandFields();
				alert('저장 완료');
				// rentList 재할당은 deep watcher 를 통해 isDirty=true 를 다시 켜므로
				// nextTick 으로 watcher flush 이후 false 를 적용해야 한다.
				this.$nextTick(() => {
					this.isDirty = editedWhileSaving;
				});
				// Y-1/Bug Y: non-exitAfter 의 router.go(currentRoute) 강제 리로드 제거.
				// 박시영 보고: in-place sub-form 저장 시 다른 sub-form 의 미저장 입력 (사진/파일/연결주소)
				// 이 init() → getItem() 으로 덮어써져 휘발. 외부 갱신 (표제부/공시지가) 은
				// btnReload 가 별도 confirm 후 수행.
				if (options && options.exitAfter) {
					this.$router.go(-1);
				}
				return { ok: true };
			});
		},
		btnReload() {
			if (
				!confirm(
					'표제부, 공시지가, 층별정보를 업데이트 하시겠습니까?\n\n업데이트후 화면이 새로고침되므로 수정중인 데이터가 유실될 수 있습니다.\n\n업데이트전에 수정중인 데이터는 저장하시기 바랍니다.',
				)
			) {
				return;
			}
			this.isLoading = true;
			// $apiPOST 는 타임아웃/5xx/네트워크 실패 시 자체 alert 후 false 를 반환하므로
			// (MapWrite.btnReload 와 동일) else-alert 를 제거해 이중 alert 을 막는다.
			this.$apiPOST('/admin/api/detail/item/reload2', { bid: this.bid }, { timeout: 90000 }).then(re => {
				// MapWrite.btnReload 와 같다: 건축물대장 조회가 실패해도 토지 정보는 갱신됐을 수 있어 토지 칸을 다시 받는다.
				// 다 받기 전에는 로딩을 풀지 않는다(그사이 저장하면 옛 값이 나간다, codex 리뷰).
				if (re === false) {
					return Promise.all([this.syncLandFields(), this.getLand()]).finally(() => {
						this.isLoading = false;
					});
				}
				this.isLoading = false;
				// '01' = 공공 건축물대장에 표제부 없음. MapWrite.btnReload 와 동일 처리.
				if (re === '01') {
					alert(
						'이 지번에는 공공 건축물대장(표제부)이 없습니다.\n\n나대지이거나 대장이 아직 등재되지 않은 지번입니다.\n건물 정보(연면적·층별·건폐율 등)는 불러올 수 없으며, 다시 시도해도 동일합니다.',
					);
					return;
				}
				// 표제부가 없어도 토지 정보는 갱신된다(서버 seon.refreshLandOnly). 아래 새로고침이 바뀐 값을 보여 준다.
				if (re && re.noTitle) {
					alert(
						'이 지번에는 공공 건축물대장(표제부)이 없어 건물 정보(연면적·층별·건폐율 등)는 불러올 수 없습니다.\n\n공시지가와 토지 정보(지목·면적·용도지역)는 갱신했습니다.\n건물이 다른 지번에 걸쳐 있으면 그 지번을 연결주소로 추가해 주세요.',
					);
				}
				// 매물 지번에 건축물대장이 없어 연결 필지의 대장으로 건물 정보를 받았다(서버 seon.titleFromLinkedParcels).
				if (re && re.titleVia) {
					alert(
						`이 지번에는 건축물대장(표제부)이 없어, 연결주소 ${re.titleVia} 의 건축물대장으로 건물 정보(연면적·층별·건폐율 등)를 불러왔습니다.`,
					);
				}
				// MapWrite.btnReload 와 동일: 못 받은 연결 필지를 알린다.
				if (re && Array.isArray(re.unrefreshed) && re.unrefreshed.length) {
					alert(
						'아래 필지는 공공데이터에서 최신 공시지가를 받지 못해 다른 필지와 기준 연도가 다를 수 있습니다.\n\n' +
							re.unrefreshed.map(p => `• ${p.jibun_addr}${p.year ? ` (${p.year}년 기준 유지)` : ''}`).join('\n') +
							'\n\n잠시 후 다시 새로고침해 주세요. 계속 같으면 폐쇄되거나 합병된 지번일 수 있으니 연결주소를 확인해 주세요.',
					);
				}
				if (re) {
					this.$router.go(this.$router.currentRoute);
				}
			});
		},
		async chkDoneLog() {
			const re = await this.$apiGET('/admin/api/log/done2?bid=' + this.bid);
			if (!re.length) {
				return true;
			} else {
				return false;
			}
		},
		async chgSellStatus() {
			// Bug AI-2: MapWrite 와 동일 — isDirty snapshot, 저장 실패 시 restore.
			const oldIsDirty = this.isDirty;
			this.onUpdateData();
			this.onUpdateFloor();

			const oldStatus = this.item.sell_status;
			const newStatus = this.sell_status;
			const name = this.$ITEM_STATE2[newStatus];
			this.building_done_log_flag = false;
			this.building_hold_log_flag = false;

			let msg = '[ ' + name + ' ] 상태로 전환하시겠습니까?';

			if (oldStatus == 'ready') {
				if (!confirm(msg)) {
					this.sell_status = oldStatus;
					return;
				}

				if (newStatus == 'done') {
					// if (confirm('누적 매물 개수에 반영하시겠습니까?') == true) {
					// 	if (await this.chkDoneLog()) {
					// 		this.building_done_log_flag = true;
					// 	} else {
					// 		this.sell_status = oldStatus;
					// 		alert('정보를 불러오는중 문제가 발생하였습니다. 잠시후에 다시 시도하시기 바랍니다.');
					// 		return;
					// 	}
					// }
				}
			} else if (oldStatus == 'done') {
				if (newStatus == 'ready') {
					this.sell_status = oldStatus;
					msg = '[ ' + name + ' ] 상태로 전환하실 수 없습니다.';
					alert(msg);
					return;
				}
			} else if (oldStatus == 'hold') {
				if (newStatus == 'ready') {
					this.sell_status = oldStatus;
					msg = '[ ' + name + ' ] 상태로 전환하실 수 없습니다.';
					alert(msg);
					return;
				}
			} else if (oldStatus == 'sell') {
				this.sell_status = oldStatus;
				msg = '[ ' + name + ' ] 상태로 전환하실 수 없습니다.';
				alert(msg);
				return;
			} else {
				if (!confirm(msg)) {
					this.sell_status = oldStatus;
					return;
				}
			}

			if (newStatus == 'done') {
				if (!this.item.building_name.length) {
					this.sell_status = oldStatus;
					alert('물건명을 입력하세요.');
					this.$refs.building_name.focus();
					return;
				}
				if (!this.item.substation.length) {
					this.sell_status = oldStatus;
					alert('주변역을 입력하세요.');
					this.$refs.substation.focus();
					return;
				}
				if (!this.item.substation_distance) {
					this.sell_status = oldStatus;
					alert('주변역과의 거리(M)을 입력하세요.');
					this.$refs.substation_distance.focus();
					return;
				}
				if (!this.item.land_size_p) {
					this.sell_status = oldStatus;
					alert('대지면적을 입력하세요.');
					this.$refs.land_size_p.focus();
					return;
				}
				if (!this.item.gmok) {
					this.sell_status = oldStatus;
					alert('지목을 선택하세요.');
					this.$refs.gmok.focus();
					return;
				}
				if (!this.item.use_area_uid) {
					this.sell_status = oldStatus;
					alert('용도지역을 선택하세요.');
					this.$refs.use_area_uid.focus();
					return;
				}
				if (!this.item.road_name) {
					this.sell_status = oldStatus;
					alert('도로명을 입력하세요.');
					this.$refs.road_name.focus();
					return;
				}
				if (!this.item.roadwide_1 && !this.item.roadwide_2 && !this.item.roadwide_3 && !this.item.roadwide_4) {
					this.sell_status = oldStatus;
					alert('도로사항을 1개이상 입력하세요.');
					this.$refs.roadwide_1.focus();
					return;
				}
				if (!this.item.owner_home_phone && !this.item.owner_office_phone && !this.owner_mobile_1) {
					this.sell_status = oldStatus;

					alert('연락처를 1개이상 입력하세요.');
					this.$refs.owner_home_phone.focus();
					return;
				}
				if (!this.item.owner_name) {
					this.sell_status = oldStatus;
					alert('소유자정보의 성명을 입력하세요.');
					this.$refs.owner_name.focus();
					return;
				}
				// if (this.item.ins_price == 0) {
				// 	this.sell_status = oldStatus;
				// 	alert('금액정보의 입금가를 입력하세요.');
				// 	// this.$refs.ins_price.focus();
				// 	return;
				// }
				// if (this.item.sell_price == 0) {
				// 	this.sell_status = oldStatus;
				// 	alert('금액정보의 매매희망가를 입력하세요.');
				// 	// this.$refs.ins_price.focus();
				// 	return;
				// }
			}

			if (!confirm(msg)) {
				this.sell_status = oldStatus;
				return;
			}
			if (oldStatus == 'done' && newStatus == 'hold' && this.building_done_log_flag) {
				if (confirm('누적 매물 개수에서 차감하시겠습니까?') == true) {
					this.building_hold_log_flag = true;
				}
			}

			this.item.sell_status = newStatus;
			//////////////////////////////////
			// 저장 call fun
			//////////////////////////////////
			// Bug AI (rent): MapWrite 와 동일 — fire-and-forget save 실패 시 UI 가
			// newStatus 로 보이지만 DB 는 oldStatus 라 사용자 오인. await + revert.
			// Bug AI-2 (rent): await 구간 동안 라디오 disabled — 더블 클릭 차단.
			// 실패 시 isDirty 도 진입 전 값으로 restore — UI 미변경 시 dirty prompt 방지.
			this.chgSellStatusPending = true;
			try {
				const re = await this.btnSaveItem();
				if ((!re || !re.ok) && this.item.sell_status === newStatus) {
					this.sell_status = oldStatus;
					this.item.sell_status = oldStatus;
					this.isDirty = oldIsDirty;
				}
			} finally {
				this.chgSellStatusPending = false;
			}
			//////////////////////////////////
		},
		// I1: 사진 슬롯 헬퍼 — 기본 라벨 / 사용자 입력 / dirty 검출.
		defaultImgLabel(idx) {
			return this.$IMG_NAME[idx];
		},
		onImgLabelInput(idx, val) {
			this.imgList[idx].label = val;
		},
		hasImgFileChanges() {
			return this.imgList.some((s) => s.fileSrc || s.id);
		},
		hasImgLabelChanges() {
			return this.imgList.some((s) => s.veiwSrc && (s.label ?? '') !== (s.initialLabel ?? ''));
		},
		hasImgAnyChanges() {
			return this.hasImgFileChanges() || this.hasImgLabelChanges();
		},
		imgDel(idx) {
			if (this.imgList[idx].src) {
				this.imgList[idx].id = this.imgList[idx].src;
			}

			this.imgList[idx].file = null;
			this.imgList[idx].src = null;
			this.imgList[idx].fileSrc = null;
			this.imgList[idx].veiwSrc = null;
			// I1: label / initialLabel 은 그대로 둔다 — 같은 슬롯에 다시 업로드하면 라벨 보존.
			// Y-1: 저장 후 applyImgListFromServer 가 서버 상태로 source of truth 를 재설정.
		},
		// Y-1/Bug Y: /up/img2 응답으로 받은 imgList/imgLabels 를 in-place patch.
		// router.go(currentRoute) 강제 리로드 대체. URL 은 image2 (임대용).
		applyImgListFromServer(payload) {
			const newImgList = Array.isArray(payload?.imgList) ? payload.imgList : [];
			const newLabels = Array.isArray(payload?.imgLabels) ? payload.imgLabels : [];
			for (let i = 0; i < this.imgList.length; i++) {
				const id = newImgList[i] ?? null;
				this.imgList[i].file = null;
				this.imgList[i].fileSrc = null;
				this.imgList[i].id = null;
				if (id) {
					this.imgList[i].src = id;
					this.imgList[i].veiwSrc = process.env.VUE_APP_HOST_BACK + '/users/item/image2?id=' + id + '&w=1200&q=82';
				} else {
					this.imgList[i].src = null;
					this.imgList[i].veiwSrc = null;
				}
				this.imgList[i].label = newLabels[i] ?? null;
				this.imgList[i].initialLabel = this.imgList[i].label;
			}
		},
		async imgFile(e, idx) {
			if (!e.target.files.length) {
				return;
			}

			let { file, base64 } = await this.$imgResize(e.target.files[0]);

			if (!file.type.match('image/.*')) {
				alert('이미지 확장자만 업로드 가능합니다.');
				return;
			}

			this.imgList[idx].file = file;
			this.imgList[idx].fileSrc = base64;
			this.imgList[idx].veiwSrc = base64;

			// let file = e.target.files[0];

			// const reader = new FileReader();
			// reader.onload = e => {
			// 	this.imgList[idx].fileSrc = e.target.result;
			// 	this.imgList[idx].veiwSrc = e.target.result;
			// };

			// reader.readAsDataURL(file);
		},
		// F-3.2: silent 옵션은 backMenu("저장하시겠습니까?" → 예) 경유 호출용.
		// silent=true 일 때 성공 alert 과 현재 라우트 재진입을 모두 생략하고 promise 를 반환해
		// 호출자(backMenu) 가 후속 btnSaveItem + exitAfter 네비게이션을 순차 실행할 수 있게 한다.
		// silent 모드 반환값: {ok, msg?}. 실패 시 호출자가 네비게이션을 중단하도록 한다.
		async onImgSave(options = {}) {
			const silent = !!(options && options.silent);

			// I1: 변경 없음 가드 — 파일/라벨 어떤 변경도 없으면 즉시 반환.
			if (!this.hasImgAnyChanges()) {
				if (!silent) alert('변경 내용이 없습니다.');
				return silent ? { ok: true } : undefined;
			}

			let delImgList = [];
			for (let i = 0; i < this.imgList.length; i++) {
				if (this.imgList[i].id) {
					delImgList.push({ bid: this.bid, id: this.imgList[i].id, idx: i });
				}
			}

			if (delImgList.length) {
				// F-3.2: await delete so {silent} 예-flow callers don't race
				// with navigation. Legacy click callers also benefit (delete
				// before upload guarantees ordering).
				const delRe = await this.$apiPOST('/admin/api/up/img2/del', { delImgList: delImgList });
				if (!delRe) {
					// silent 모드에서는 호출자가 alert 를 띄우므로 여기선 생략.
					return silent
						? { ok: false, msg: '이미지 삭제 중 오류가 발생했습니다. 잠시후 다시 시도해주세요.' }
						: undefined;
				}
			}

			const re = await this.$apiIMG('/admin/api/up/img2', this.bid, this.imgList);
			if (!re) {
				return silent
					? { ok: false, msg: '이미지 업로드 중 오류가 발생했습니다. 잠시후 다시 시도해주세요.' }
					: undefined;
			}
			// Y-1/Bug Y: backend 가 새 imgList 를 응답에 실어주므로 in-place patch.
			// 기존 router.go(currentRoute) 강제 리로드는 init() → getItem() 으로 임대차/금액 등
			// 미저장 입력을 덮어써 박시영 보고 케이스 발생.
			//
			// Y-2 (Codex 지적): 응답 shape 가드. ok===true + 길이 일치 일 때만 적용해
			// 빈 imgList 로 destructive clear 되는 케이스 차단 (rolling deploy 시 구버전
			// boolean true 응답 포함).
			const payloadOk =
				re && re.ok === true &&
				Array.isArray(re.imgList) &&
				re.imgList.length === this.imgList.length &&
				Array.isArray(re.imgLabels) &&
				re.imgLabels.length === this.imgList.length;
			if (payloadOk) {
				this.applyImgListFromServer(re);
			}
			if (!silent) {
				if (payloadOk) {
					alert('이미지 저장 완료');
				} else {
					alert('이미지는 저장됐으나 화면 갱신에 실패했습니다.\n새로고침 후 확인해주세요.');
				}
				return re;
			}
			return { ok: true };
		},

		async fileFile(e) {
			if (!e.target.files.length) {
				return;
			}

			this.fileObj = e.target.files[0];
		},
		onFileSave() {
			if (!this.fileName.length) {
				alert('파일명을 입력해 주세요.');
				return;
			}

			if (!this.fileObj) {
				alert('파일을 첨부해 주세요.');
				return;
			}

			if (this.fileUploading) return; this.fileUploading = true; this.$apiFILE('/admin/api/up/file2', this.bid, this.fileObj, this.fileName).then(re => { this.fileUploading = false;
				if (re) {
					alert('저장 완료');
					// Y-1/Bug Y: router.go(currentRoute) 리로드 제거 — 사진/임대차/금액 미저장 입력 휘발 차단.
					this.fileName = '';
					this.fileObj = null;
					this.getFileList();
				}
			});
		},
		getFileList() {
			this.$apiGET('/admin/api/up/file2?bid=' + this.bid).then(re => {
				if (Array.isArray(re)) this.fileList = re;
			});
		},
		saveFileName(f) {
			if (!f.usr_name.length) {
				alert('파일명을 입력해 주세요.');
				return;
			}

			// Bug AP: 기존엔 fire-and-forget — backend 5xx 시 $apiPOST 가 SP+sqlMessage
			// alert 한 뒤 false resolve 하지만 v-model 로 이미 변경된 f.usr_name 은
			// 로컬에 남아있어 UI 는 변경 성공처럼 보임. 다음 reload 에 서버 OLD 이름으로
			// reverted → 사용자 혼란. delFile (Bug T) 와 동일 패턴. (rent 분기)
			//
			// Codex P2 follow-up: 단순 getFileList() 는 다른 row 의 in-flight 편집을
			// 덮어쓸 수 있음. 실패한 row 만 surgical 하게 server truth 로 되돌리고,
			// 이미 사용자가 더 입력했다면 (local !== submitted) 건드리지 않는다.
			const submittedName = f.usr_name;
			const failedId = f.id;
			this.$apiPOST('/admin/api/up/file/update2', { id: failedId, name: submittedName }).then(re => {
				if (re === true) return;
				this.$apiGET('/admin/api/up/file2?bid=' + this.bid).then(serverList => {
					if (!Array.isArray(serverList)) return;
					const localRow = this.fileList.find(r => r.id === failedId);
					if (!localRow) return;
					// 사용자가 실패 직후 다시 입력했다면 그 입력을 우선.
					if (localRow.usr_name !== submittedName) return;
					const srvRow = serverList.find(s => s.id === failedId);
					if (srvRow) localRow.usr_name = srvRow.usr_name;
				});
			});
		},
		delFile(id, idx) {
			// J-2/Bug T: backend 5xx 시 splice 가 진행되어 사용자는 삭제됐다고 인식.
			this.$apiPOST('/admin/api/up/file/delete2', { id: id }).then(re => {
				if (re !== true) return;
				this.fileList.splice(idx, 1);
			});
		},
		downFile(id, item) {
			this.$apiDOWN('/admin/api/up/file/item2?id=' + id, item.type).then(re => {
				const url = window.URL.createObjectURL(new Blob([re]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', item.org_name); //or any other extension
				document.body.appendChild(link);
				link.click();
			});
		},
		delItem() {
			if (confirm('선택한 물건을 삭제하시겠습니까?') == true) {
				this.$apiPOST('/admin/api/detail/item/delete2', { bid: this.bid }).then(re => {
					// J-2/Bug P: backend success → true / fail → 5xx (resolves false) /
					// 401 → 로그인 redirect (resolves undefined). 실패 시 창을 닫으면
					// alert 가 사라지고 사용자가 메시지를 놓치므로 success 일 때만 close.
					if (re !== true) return;
					window.close();
				});
			}
		},
		goKras() {
			var link =
				'http://kras.seoul.go.kr/land_info/info/baseInfo/baseInfo.do?service=baseInfo&landcode=' +
				this.item.pnu_code +
				'&gblDivName=baseInfo&scale=0&gyujae=0&label_type=false#t01-tab';
			window.open(link);
		},
		btnMgrLogDel(id) {
			this.$apiPOST('/admin/api/mgr/log/del2', {
				id: id,
			}).then(() => {
				this.getMgrLog();
			});
		},
		btnClientLogDel(id) {
			this.$apiPOST('/admin/api/client/log/del2', {
				id: id,
			}).then(() => {
				this.getClientLog();
			});
		},
		btnOnPrint() {
			let w = window.screen.availWidth;
			let h = window.screen.availHeight;

			let attr = 'width=' + w + ', height=' + h + ', resizable=no, status=no';

			window.open('/RentPrintPage?bid=' + this.bid, '', attr);
		},
		btnOnCreateMap() {
			this.$loadScript(
				'https://oapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=' +
					process.env.VUE_APP_NAVER_API_ID +
					'&submodules=geocoder',
			)
				.then(() => {
					this.marker?.setMap(null);
					this.mapType = new window.naver.maps.CadastralLayer();

					this.isPopupShow6 = true;
					this.$nextTick(() => {
						this.loadMap();
					});
				})
				.catch(() => {});
		},
		loadMap() {
			this.map = new window.naver.maps.Map('createMap', {
				center: new window.naver.maps.LatLng(37.5112, 127.0981),
				zoom: 19,
			});

			this.mapType.setMap(this.map);
		},
		searchAddress() {
			// H-3: 빈 주소는 Naver geocode 가 "query is missing!" 로 동기 throw → 사용자 가드 추가.
			const q = String(this.adr || "").trim();
			if (!q) {
				alert('주소를 입력하세요.');
				return;
			}
			window.naver.maps.Service.geocode({ address: q }, function (status, re) {
				if (status !== window.naver.maps.Service.Status.OK) {
					// H-3: 구체적인 에러 노출 — errorMessage / status / 네트워크 실패 구분해서 진단 가능하게.
					console.error('[naver geocode] status=', status, 're=', re);
					const detail = (re && re.errorMessage) || ('status ' + status);
					alert('주소검색 실패: ' + detail);
					return;
				}
				if (!re || !re.result || !re.result.total) {
					alert('검색결과가 없습니다.');
					return;
				}

				window.resultAddress2(re.v2.addresses[0]);
			});
		},
		resultAddress2(item) {
			this.marker?.setMap(null);
			this.jibunAddress = '';
			this.roadAddress = '';
			this.zonecode = null;

			if (item.jibunAddress.indexOf(item.addressElements[6].longName) != -1) {
				let str = item.jibunAddress.split(' ');

				for (let i = 0; i < str.length; i++) {
					if (str[i] == item.addressElements[6].longName) {
						str.splice(i, 1);

						item.jibunAddress = str.join(' ');
					}
				}
			}
			// F-2.1: $normalizeAddr 로 통일 (서울특별시/서울시→서울, 번지 제거,
			// 공백 정리). Naver reverseGeocode 가 "서울특별시 … 41번지" 또는
			// "서울시 … 41" 등 다양한 형태로 응답해도 단일 boundary 에서 정규화.
			item.jibunAddress = this.$normalizeAddr(item.jibunAddress);
			this.jibunAddress = item.jibunAddress;

			if (item.roadAddress.indexOf(item.addressElements[6].longName) != -1) {
				let str = item.roadAddress.split(' ');

				for (let i = 0; i < str.length; i++) {
					if (str[i] == item.addressElements[6].longName) {
						str.splice(i, 1);

						item.roadAddress = str.join(' ');
					}
				}
			}

			item.roadAddress = this.$normalizeAddr(item.roadAddress);
			this.roadAddress = item.roadAddress;

			if (this.roadAddress) {
				this.roadAddress += '(' + item.addressElements[2].longName + ')';
			}

			this.point = { x: item.x, y: item.y };
			this.zonecode = item.addressElements[8].longName == '' ? 0 : Number(item.addressElements[8].longName);

			this.map.setCenter({ lat: this.point.y, lng: this.point.x });

			this.marker = new window.naver.maps.Marker({
				position: new window.naver.maps.LatLng(this.point.y, this.point.x),
				map: this.map,
			});
		},
		btnOnStage() {
			if (!this.adr.length) {
				alert('주소를 입력하세요.');
				return;
			}
			if (!this.roadAddress && !this.jibunAddress) {
				alert('검색된 주소가 없습니다. 주소를 검색해주세요.');
				return;
			}

			const isDup = this.stagedAddresses.some(
				s => s.road_addr === this.roadAddress && s.jibun_addr === this.jibunAddress
			);
			if (isDup) {
				alert('이미 추가된 주소입니다.');
				return;
			}

			this.stagedAddresses.push({
				road_addr: this.roadAddress,
				jibun_addr: this.jibunAddress,
				lat: this.point.y,
				lng: this.point.x,
			});

			this.adr = '';
			this.roadAddress = '';
			this.jibunAddress = '';
		},
		btnOnStagedRemove(idx) {
			this.stagedAddresses.splice(idx, 1);
		},
		// F-3.2: silent=true 는 backMenu(저장하시겠습니까? → 예) 경유 호출용. 추가 확인 팝업과
		// 성공 후 currentRoute 재진입을 생략하고 staged 초기화만 수행해, 이어지는
		// btnSaveItem({exitAfter:true}) 의 router.go(-1) 로 네비게이션을 일원화한다.
		// 클릭 이벤트로 호출되는 일반 경로(확인 버튼) 는 options 가 MouseEvent 이므로 silent=false 로 평가됨.
		// 반환: silent 모드에서는 {ok, msg?} 구조. 실패 시 호출자가 네비게이션을 중단하도록 한다.
		async btnOnBatchSave(options = {}) {
			const silent = !!(options && options.silent === true);
			if (!this.stagedAddresses.length) {
				return silent ? { ok: true } : undefined;
			}
			if (!silent && !confirm('연결주소 ' + this.stagedAddresses.length + '건을 등록하시겠습니까?')) {
				return;
			}

			this.isLoading = true;
			try {
				let hasError = false;
				const unrefreshed = [];

				for (const addr of this.stagedAddresses) {
					const re = await this.$apiPOST('/admin/api/detail/item/link/add2', {
						bid: this.bid,
						road_addr: addr.road_addr,
						jibun_addr: addr.jibun_addr,
						lat: addr.lat,
						lng: addr.lng,
					});
					if (!re) {
						hasError = true;
						break;
					}
					if (Array.isArray(re.unrefreshed)) unrefreshed.push(...re.unrefreshed);
				}
				// 등록에 성공한 만큼 서버가 대지면적·공시지가 합계를 다시 냈다. 실패해서 멈췄어도 앞의 등록분은 반영됐다.
				await this.syncLandFields();

				if (hasError) {
					// silent 모드에서는 호출자(backMenu) 가 단일 alert 를 띄우므로 중복 alert 생략.
					if (!silent) {
						alert('API Server ERROR 잠시후 다시 시도해주세요.');
					}
					return silent ? { ok: false, msg: '연결주소 등록 중 오류가 발생했습니다. 잠시후 다시 시도해주세요.' } : undefined;
				}
				this.stagedAddresses = [];
				// 새 필지보다 옛 연도에 머문 필지를 함께 갱신하다 못 받은 필지(서버 refreshStaleParcels).
				if (!silent && unrefreshed.length) {
					alert(
						'연결주소는 등록했습니다. 다만 아래 필지는 공공데이터에서 최신 공시지가를 받지 못해 다른 필지와 기준 연도가 다를 수 있습니다.\n\n' +
							unrefreshed.map(p => `• ${p.jibun_addr}${p.year ? ` (${p.year}년 기준 유지)` : ''}`).join('\n') +
							'\n\n잠시 후 공시지가 새로고침을 눌러 주세요. 계속 같으면 폐쇄되거나 합병된 지번일 수 있습니다.',
					);
				}
				if (!silent) {
					// Bug AA: location.reload() 제거 — Bug Y 동일 사유의 회귀.
					// 박시영 보고: 연결주소 일괄등록(확인) 누르면 main form 의 미저장 임대차/특징/
					// 금액/주변역 입력이 init() → getItem() 으로 휘발. 사진은 별도 경로라 살아남는다.
					// 변경된 것은 연결주소뿐이므로 addrList(linkAddr 갱신 포함) + landList(토지대장)만
					// surgical 재페치한다.
					// Codex round-1: 재페치를 await 해서 isLoading 이 fresh 데이터 도착 전에 풀리며
					// 사용자가 stale 한 row 를 클릭하는 윈도우를 막는다.
					await Promise.all([this.getAddrList(), this.getLand()]);
				}
				return silent ? { ok: true } : undefined;
			} finally {
				this.isLoading = false;
			}
		},
		btnOnCreate() {
			// Legacy: kept for backward compatibility, now uses btnOnStage
			this.btnOnStage();
		},
		async btnOnDelete(id, idx) {
			this.isLoading = true;
			try {
				const re = await this.$apiPOST('/admin/api/detail/item/link/delete2', {
					id: id,
					idx: idx,
					bid: this.bid,
				});
				if (re) {
					// Bug AA: location.reload() 제거 — btnOnBatchSave 와 동일 사유.
					// 미저장 main form 입력이 휘발하지 않도록 addrList + landList 만 재페치.
					// Codex round-1: 재페치를 await 해서 isLoading 이 stale 데이터를 노출하지 않도록.
					await Promise.all([this.getAddrList(), this.getLand(), this.syncLandFields()]);
				}
				// Bug P: 실패 분기 generic alert 제거 — backend 5xx 가 SP+sqlMessage
				// 를 message 로 담고 $apiPOST 가 alert 하므로 중복 표시 시 구체 원인 손실.
			} finally {
				this.isLoading = false;
			}
		},
		getAddrList() {
			// Codex round-1: caller (btnOnBatchSave/btnOnDelete) 가 await 가능하도록 promise 반환.
			return this.$apiGET('/admin/api/detail/item/edit/land2?bid=' + this.bid).then(data => {
				let jinbun_addr = '';

				// F-2.1: 연결주소 목록·linkAddr 두 경로가 같은 출처를 쓰므로 ingestion 시
				// 한 번에 정규화해 둔다. 이후의 dedup / splice / join 은 모두 정규화된 값 기준.
				data.forEach(d => {
					d.jibun_addr = this.$normalizeAddr(d.jibun_addr);
					d.road_addr = this.$normalizeAddr(d.road_addr);
				});

				this.addrList = JSON.parse(JSON.stringify(data));

				for (let i = 0; i < data.length; i++) {
					if (data[i].land_index == 1) {
						this.addrList.splice(i, 1);
						break;
					}
				}

				// F-2.3: 중복 주소 제거 후 결합 — jibun_addr 는 위에서 정규화되어 있으므로
				// dedup 과 화면 표기가 동일한 기준으로 이뤄진다.
				// formatLinkAddr: 첫 주소는 풀주소 유지, 2번째부터는 "시 구" 제거해 "동 번지" 만.
				const uniqueAddrs = [...new Set(data.map(d => d.jibun_addr).filter(Boolean))];
				jinbun_addr = this.$formatLinkAddr(uniqueAddrs) || this.item.jibun_addr;

				this.linkAddr = jinbun_addr;
			});
		},

		btnOnLinkAdd(bid) {
			this.$apiPOST('/admin/api/detail/item/link/b/add2', {
				bid: bid,
				ref_bid: this.bid,
			}).then(re => {
				if (re) {
					this.getList();
					alert('등록 완료');
				}
			});
		},
		btnOnLinkDel(bid) {
			this.$apiPOST('/admin/api/detail/item/link/b/delete2', {
				bid: bid,
				ref_bid: this.bid,
			}).then(re => {
				if (re) {
					this.getList();
				}
			});
		},
		getList() {
			this.$apiGET('/admin/api/detail/item/b/link2?bid=' + this.bid).then(re => {
				this.linkList = JSON.parse(JSON.stringify(re));

				let itemList = [];

				itemList = itemList.concat(this.linkSumObj.item, JSON.parse(JSON.stringify(re)));

				this.linkSumObj.itemList = [];
				this.linkSumObj.itemList = itemList;

				this.linkSumObj.sum_monthly_rent = 0;
				this.linkSumObj.sum_deposit = 0;
				this.linkSumObj.sum_main_fee = 0;
				this.linkSumObj.sum_monthly_fixed = 0;
				this.linkSumObj.sum_rent_area_m2 = 0;
				this.linkSumObj.sum_rent_area_py = 0;
				this.linkSumObj.sum_rent_py_price = 0;
				this.linkSumObj.sum_net_area_m2 = 0;
				this.linkSumObj.sum_net_area_py = 0;
				this.linkSumObj.sum_ex_rate = 0;
				this.linkSumObj.sum_land_price = 0;
				this.linkSumObj.sum_land_size_py_price = 0;
				this.linkSumObj.sum_building_price = 0;
				this.linkSumObj.sum_building_price_py_price = 0;
				this.linkSumObj.sum_total_size_py_price = 0;
				this.linkSumObj.sum_land_size_m2 = 0;
				this.linkSumObj.sum_land_size_p = 0;
				this.linkSumObj.sum_public_land_price = 0;
				this.linkSumObj.sum_public_land_price_py_price = 0;
				this.linkSumObj.sum_total_size_m2 = 0;
				this.linkSumObj.sum_total_size_p = 0;
				this.linkSumObj.sum_build_size_m2 = 0;
				this.linkSumObj.sum_build_size_p = 0;

				for (let i = 0; i < this.linkSumObj.itemList.length; i++) {
					this.linkSumObj.sum_monthly_rent += Number(this.linkSumObj.itemList[i].monthly_rent);
					this.linkSumObj.sum_deposit += Number(this.linkSumObj.itemList[i].deposit);
					this.linkSumObj.sum_main_fee += Number(this.linkSumObj.itemList[i].main_fee);
					this.linkSumObj.sum_monthly_fixed += Number(this.linkSumObj.itemList[i].monthly_fixed);
					this.linkSumObj.sum_rent_area_m2 += Number(this.linkSumObj.itemList[i].rent_area_m2);
					this.linkSumObj.sum_rent_area_py += Number(this.linkSumObj.itemList[i].rent_area_py);
					this.linkSumObj.sum_rent_py_price += Number(this.linkSumObj.itemList[i].rent_py_price);
					this.linkSumObj.sum_net_area_m2 += Number(this.linkSumObj.itemList[i].net_area_m2);
					this.linkSumObj.sum_net_area_py += Number(this.linkSumObj.itemList[i].net_area_py);
					this.linkSumObj.sum_ex_rate += Number(this.linkSumObj.itemList[i].ex_rate);

					this.linkSumObj.sum_land_price += Number(this.linkSumObj.itemList[i].land_price);
					this.linkSumObj.sum_land_size_py_price += Number(this.linkSumObj.itemList[i].land_size_py_price);
					this.linkSumObj.sum_building_price += Number(this.linkSumObj.itemList[i].building_price);
					this.linkSumObj.sum_building_price_py_price += Number(this.linkSumObj.itemList[i].building_price_py_price);
					this.linkSumObj.sum_total_size_py_price += Number(this.linkSumObj.itemList[i].total_size_py_price);
					this.linkSumObj.sum_land_size_m2 += Number(this.linkSumObj.itemList[i].land_size_m2);
					this.linkSumObj.sum_land_size_p += Number(this.linkSumObj.itemList[i].land_size_p);
					this.linkSumObj.sum_public_land_price += Number(this.linkSumObj.itemList[i].public_land_price);
					this.linkSumObj.sum_public_land_price_py_price += Number(
						this.linkSumObj.itemList[i].public_land_price_py_price,
					);
					this.linkSumObj.sum_total_size_m2 += Number(this.linkSumObj.itemList[i].total_size_m2);
					this.linkSumObj.sum_total_size_p += Number(this.linkSumObj.itemList[i].total_size_p);
					this.linkSumObj.sum_build_size_m2 += Number(this.linkSumObj.itemList[i].build_size_m2);
					this.linkSumObj.sum_build_size_p += Number(this.linkSumObj.itemList[i].build_size_p);
				}
			});
		},
		getBuildingList(pg) {
			this.$apiGET(
				'/admin/api/user/admin/detail/building2?page=' +
					(pg - 1) * this.buildingPage.itemSize +
					'&keyword=' +
					this.searchInfo.keyword +
					'&st=' +
					this.searchInfo.st_,
			).then(data => {
				this.buildingList = data.item;

				this.buildingPage.totalCount = data.pageInfo.totalCount;
				this.buildingPage.page = pg;
				this.buildingPage.pageData = this.$pageDataSetting(
					this.buildingPage.totalCount,
					this.buildingPage.itemSize,
					this.buildingPage.blockSize,
					this.buildingPage.page,
				);
			});
		},
		getPhoneMask(phoneNumber, cur) {
			if (!phoneNumber) return phoneNumber;
			// 공동소유 물건에서는 한 칸에 연락처를 여러 개 나열한다(그래서 컬럼도 50자로 늘렸다).
			// 종전에는 숫자 아닌 문자를 전부 지우고 남은 숫자를 하나의 번호로 재조합해 두 번호를
			// 붙여버렸다 — 운영 실데이터 "02314148130109194994" 가 그 결과다. 구분자(쉼표·슬래시·
			// 줄바꿈)를 보존한 채 조각별로 마스킹한다. 단일 번호 결과는 종전과 동일하다.
			this.item[cur] = String(phoneNumber)
				.split(/([,/\n]+)/)
				.map(part => (/[,/\n]/.test(part) ? part : this.maskOnePhone(part)))
				.join('');
		},
		/** 번호 한 개를 010-1234-5678 / 02-123-4567 형태로 만든다. 앞뒤 공백은 그대로 둔다. */
		maskOnePhone(part) {
			const m = String(part).match(/^(\s*)([\s\S]*?)(\s*)$/);
			const lead = m[1];
			const tail = m[3];
			const phoneNumber = m[2].replace(/[^0-9]/g, '');
			// 숫자가 하나도 없는 조각(예: 내선 안내 문구)은 사용자가 적은 대로 남긴다.
			if (!phoneNumber) return part;

			let res = '';
			if (phoneNumber.length < 3) {
				res = phoneNumber;
			} else {
				if (phoneNumber.substr(0, 2) == '02') {
					if (phoneNumber.length <= 5) {
						//02-123-5678
						res = phoneNumber.substr(0, 2) + '-' + phoneNumber.substr(2, 3);
					} else if (phoneNumber.length > 5 && phoneNumber.length <= 9) {
						//02-123-5678
						res = phoneNumber.substr(0, 2) + '-' + phoneNumber.substr(2, 3) + '-' + phoneNumber.substr(5);
					} else if (phoneNumber.length > 9) {
						//02-1234-5678
						res = phoneNumber.substr(0, 2) + '-' + phoneNumber.substr(2, 4) + '-' + phoneNumber.substr(6);
					}
				} else {
					if (phoneNumber.length < 8) {
						res = phoneNumber;
					} else if (phoneNumber.length == 8) {
						res = phoneNumber.substr(0, 4) + '-' + phoneNumber.substr(4);
					} else if (phoneNumber.length == 9) {
						res = phoneNumber.substr(0, 3) + '-' + phoneNumber.substr(3, 3) + '-' + phoneNumber.substr(6);
					} else if (phoneNumber.length == 10) {
						res = phoneNumber.substr(0, 3) + '-' + phoneNumber.substr(3, 3) + '-' + phoneNumber.substr(6);
					} else if (phoneNumber.length > 10) {
						//010-1234-5678
						res = phoneNumber.substr(0, 3) + '-' + phoneNumber.substr(3, 4) + '-' + phoneNumber.substr(7);
					}
				}
			}

			return lead + res + tail;
		},
	},
};
</script>

<style lang="scss" scoped>
// F-3.3: 편집모드 우측 "작업내역 / 변경내역" 탭 박스를 고정 높이 + 내부 스크롤로
// 누적된 로그가 세로로 계속 길어져 좌측 임대차내역을 아래로 밀어내는 문제 방지.
// .right .con 은 SFC 내 다른 .con (소유자정보 등) 과 충돌하므로 전용 클래스로 범위 한정.
.work-history-panel {
	display: flex;
	flex-direction: column;

	.tab-btn {
		flex: 0 0 auto;
	}

	// 외부 래퍼(.tab-con) 만 고정 높이 + 스크롤. 내부 각 탭 .tab-con 은 자연 크기.
	> .tab-con {
		flex: 1 1 auto;
		max-height: 600px;
		overflow-y: auto;
		overflow-x: hidden;
	}
}

// F-3.5 제외 row 연회색 처리 스타일은 assets/css/common.scss 로 이동 (전역 단일 정의).

.work-row td,
.work-row:hover td {
	background-color: #FFF9C4 !important;
}

// I1: 물건사진 업로드 모달 — v-for 그리드 + 슬롯 번호 배지 + 빈/채움 상태 + 라벨 인풋.
.photo-grid {
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	gap: 12px;
	list-style: none;
	padding: 0;
	margin: 0 0 16px;
}
@media (max-width: 1024px) {
	.photo-grid { grid-template-columns: repeat(3, 1fr); }
}
@media (max-width: 640px) {
	.photo-grid { grid-template-columns: repeat(2, 1fr); }
}
.photo-list--item {
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 6px;

	.slot-num {
		position: absolute;
		top: 6px;
		left: 6px;
		background: rgba(0, 0, 0, .55);
		color: #fff;
		font-size: 11px;
		padding: 2px 6px;
		border-radius: 10px;
		z-index: 2;
		pointer-events: none;
	}

	.file > .img {
		aspect-ratio: 4 / 3;
		background: #f5f5f7;
		border: 1px dashed transparent;
		border-radius: 6px;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	&.is-empty .file > .img {
		border-color: #d0d4dc;
		background: #fafbfc;
	}

	.placeholder {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 4px;
		color: #8a8f99;
		font-size: 12px;
	}

	.file > .img img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.btn-delete {
		position: absolute;
		top: 6px;
		right: 6px;
		opacity: 0;
		transition: opacity .15s;
		z-index: 2;
	}
	&:hover .btn-delete,
	&.is-filled .btn-delete {
		opacity: 1;
	}

	.label-input {
		width: 100%;
		font-size: 12px;
		padding: 4px 6px;
		border: 1px solid transparent;
		border-radius: 4px;
		background: transparent;
		min-width: 0;

		&:hover:not(:disabled),
		&:focus {
			border-color: #c5cad3;
			background: #fff;
			outline: none;
		}

		&:disabled {
			color: #8a8f99;
			cursor: default;
		}
	}
}
</style>
